{
  "user": {
    "form": {
      "addTitle": "สร้างผู้ใช้งาน",
      "editTitle": "แก้ไขผู้ใช้งาน",
      "fields": {
        "username": "ชื่อผู้ใช้",
        "email": "อีเมล",
        "fullName": "ชื่อ-นามสกุล",
        "password": "รหัสผ่าน",
        "confirmPassword": "ยืนยันรหัสผ่าน",
        "facility": "สถานพยาบาล",
        "roles": "บทบาท",
        "active": "ใช้งาน",
        "allFacilities": "ทุกสถานพยาบาล (ทั้งระบบสุขภาพ)",
        "globalAccessAck": "ข้าพเจ้าเข้าใจว่านี่เป็นการให้สิทธิ์เข้าถึงทุกสถานพยาบาล",
        "departments": "แผนก",
        "primaryDepartment": "แผนกหลัก",
        "roleFacility": "สถานพยาบาลสำหรับ {{role}}",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ เพิ่มสถานพยาบาล",
        "removeFacilityFromRole": "ลบหนึ่งรายการ",
        "otherRoles": "อื่น ๆ"
      },
      "errors": {
        "usernameMin": "ชื่อผู้ใช้ต้องมีอย่างน้อย {{min}} ตัวอักษร",
        "emailInvalid": "รูปแบบอีเมลไม่ถูกต้อง",
        "passwordMin": "รหัสผ่านต้องมีอย่างน้อย {{min}} ตัวอักษร",
        "confirmPasswordRequired": "กรุณายืนยันรหัสผ่าน",
        "passwordMismatch": "รหัสผ่านไม่ตรงกัน",
        "rolesRequired": "ต้องเลือกอย่างน้อยหนึ่งบทบาท",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "โปรดยืนยันการให้สิทธิ์ทั้งระบบสุขภาพก่อนบันทึก"
      },
      "submit": {
        "create": "สร้างผู้ใช้งาน",
        "update": "อัปเดตผู้ใช้งาน"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างผู้ใช้งานสำเร็จ",
        "updatedSuccess": "อัปเดตผู้ใช้งานสำเร็จ",
        "saveError": "บันทึกผู้ใช้งานไม่สำเร็จ",
        "departmentsSaveError": "บันทึกผู้ใช้แล้ว แต่การกำหนดแผนกล้มเหลว โปรดแก้ไขผู้ใช้เพื่อลองใหม่"
      },
      "globalAccessWarning": "การตั้งค่านี้ให้สิทธิ์เข้าถึงผู้ป่วยของ “ทุก” สถานพยาบาล ไม่ใช่เพียงขอบเขตการแจ้งเตือน ใช้เฉพาะกับเจ้าหน้าที่ที่ดูแลทั้งระบบสุขภาพจริง ๆ เช่น เจ้าหน้าที่เวรเรียก",
      "departmentsHint": "แผนกที่บัญชีนี้ปฏิบัติงาน ใช้สำหรับการระบุที่มาเท่านั้น ไม่ได้ให้สิทธิ์เข้าถึงผู้ป่วย",
      "noDepartments": "ยังไม่มีการตั้งค่าแผนก"
    },
    "list": {
      "title": "การจัดการผู้ใช้",
      "subtitle": "จัดการผู้ใช้ระบบ บทบาท และการเข้าถึง",
      "columns": {
        "username": "ชื่อผู้ใช้",
        "fullName": "ชื่อ-นามสกุล",
        "email": "อีเมล",
        "roles": "บทบาท",
        "facility": "สถานพยาบาล",
        "status": "สถานะ",
        "lastLogin": "เข้าใช้ครั้งล่าสุด",
        "actions": "การดำเนินการ",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "ค้นหาผู้ใช้...",
        "allRoles": "ทุกบทบาท",
        "allFacilities": "ทุกสถานพยาบาล",
        "allStatus": "ทุกสถานะ",
        "active": "ใช้งาน",
        "inactive": "ปิดใช้งาน"
      },
      "actions": {
        "new": "สร้างผู้ใช้",
        "editTitle": "แก้ไขผู้ใช้",
        "resetPasswordTitle": "รีเซ็ตรหัสผ่าน",
        "activate": "เปิดใช้งาน",
        "deactivate": "ปิดใช้งาน",
        "activateAria": "เปิดใช้งานผู้ใช้",
        "deactivateAria": "ปิดใช้งานผู้ใช้"
      },
      "lastLoginNever": "ไม่เคย",
      "empty": "ไม่พบผู้ใช้ที่ตรงกับตัวกรองของคุณ",
      "pagination": {
        "summary": "แสดง {{from}}-{{to}} จาก {{total}}"
      },
      "toast": {
        "activated": "เปิดใช้งานผู้ใช้ {{username}} แล้ว",
        "deactivated": "ปิดใช้งานผู้ใช้ {{username}} แล้ว",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "ทุกสถานพยาบาล",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "ใช้งาน",
      "inactive": "ปิดใช้งาน",
      "locked": "ถูกล็อก",
      "pendingActivation": "รอการเปิดใช้งาน"
    },
    "mfaStatus": {
      "enrolled": "ลงทะเบียนแล้ว",
      "notEnrolled": "ยังไม่ลงทะเบียน",
      "exempt": "ได้รับการยกเว้น"
    }
  },
  "role": {
    "form": {
      "addTitle": "สร้างบทบาท",
      "editTitle": "แก้ไขบทบาท",
      "fields": {
        "name": "ชื่อบทบาท",
        "code": "รหัสบทบาท",
        "description": "รายละเอียด",
        "category": "หมวดหมู่",
        "parentRole": "บทบาทหลัก (สืบทอดสิทธิ์)"
      },
      "options": {
        "none": "ไม่มี"
      },
      "errors": {
        "nameRequired": "กรุณาระบุชื่อบทบาท",
        "codeRequired": "กรุณาระบุรหัสบทบาท"
      },
      "submit": {
        "create": "สร้างบทบาท",
        "update": "อัปเดตบทบาท"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างบทบาทสำเร็จ",
        "updatedSuccess": "อัปเดตบทบาทสำเร็จ",
        "saveError": "บันทึกบทบาทไม่สำเร็จ"
      }
    },
    
    "status": {
      "active": "ใช้งาน",
      "inactive": "ปิดใช้งาน"
    },
    "source": {
      "own": "ของตน",
      "inherited": "สืบทอด",
      "category": "หมวดหมู่"
    },
    "permissions": {
      "ownTitle": "แก้ไขสิทธิ์",
      "deniedTitle": "แก้ไขสิทธิ์ที่ปฏิเสธ",
      "ownSubtitle": "ได้รับ {{granted}} จาก {{total}} สิทธิ์ที่สืบทอดและสิทธิ์เริ่มต้นของหมวดหมู่จะแสดงในเมทริกซ์การเข้าถึง หน้านี้จัดการเฉพาะสิทธิ์ของบทบาทเท่านั้น",
      "deniedSubtitle": "สิทธิ์ที่ปฏิเสธจะลบล้างสิทธิ์จากบทบาทเอง บทบาทต้นทาง และค่าเริ่มต้นของหมวดหมู่ ติ๊กสิทธิ์เพื่อปฏิเสธอย่างชัดเจนสำหรับบทบาทนี้",
      "invalidRoleId": "รหัสบทบาทไม่ถูกต้อง",
      "save": "บันทึกสิทธิ์",
      "saveDenied": "บันทึกสิทธิ์ที่ปฏิเสธ",
      "cancel": "ยกเลิก",
      "toast": {
        "updatedSuccess": "อัปเดตสิทธิ์เรียบร้อย",
        "deniedUpdatedSuccess": "อัปเดตสิทธิ์ที่ปฏิเสธเรียบร้อย",
        "saveError": "บันทึกสิทธิ์ไม่สำเร็จ",
        "saveDeniedError": "บันทึกสิทธิ์ที่ปฏิเสธไม่สำเร็จ"
      },
      "permissionGroup": {
        "analytics": "การวิเคราะห์",
        "audit": "การตรวจสอบ",
        "billing": "การเรียกเก็บเงิน",
        "bloodProduct": "ผลิตภัณฑ์เลือด",
        "consent": "ความยินยอม",
        "dietOrder": "คำสั่งอาหาร",
        "discharge": "จำหน่ายผู้ป่วย",
        "documentation": "เอกสาร",
        "encounter": "การตรวจรักษา",
        "infection": "การควบคุมการติดเชื้อ",
        "licensing": "การออกใบอนุญาต",
        "medication": "ยา",
        "notification": "การแจ้งเตือน",
        "order": "คำสั่ง",
        "patient": "ผู้ป่วย",
        "referral": "การส่งต่อ",
        "research": "การวิจัย",
        "restraint": "การควบคุมร่างกาย",
        "result": "ผลลัพธ์",
        "scheduling": "การจัดตาราง",
        "system": "ระบบ",
        "transfer": "การย้าย",
        "user": "ผู้ใช้งาน",
        "schedule": "ตารางเวลา",
        "admin": "การจัดการ",
        "report": "รายงาน",
        "other": "อื่น ๆ"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "สร้างหมวดหมู่",
      "editTitle": "แก้ไขหมวดหมู่",
      "fields": {
        "name": "ชื่อหมวดหมู่",
        "code": "รหัสหมวดหมู่",
        "description": "คำอธิบาย",
        "sessionTimeout": "หมดเวลาเซสชัน (นาที)",
        "maxFailedLogins": "จำนวนล็อกอินล้มเหลวสูงสุด",
        "mfaRequired": "บังคับใช้ MFA สำหรับหมวดหมู่นี้"
      },
      "placeholders": {
        "code": "เช่น CLINICAL"
      },
      "errors": {
        "nameRequired": "ต้องระบุชื่อหมวดหมู่",
        "codeRequired": "ต้องระบุรหัสหมวดหมู่"
      },
      "submit": {
        "create": "สร้างหมวดหมู่",
        "update": "อัปเดตหมวดหมู่"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างหมวดหมู่สำเร็จ",
        "updatedSuccess": "อัปเดตหมวดหมู่สำเร็จ",
        "saveError": "บันทึกหมวดหมู่ไม่สำเร็จ"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "ไม่มี",
      "basic": "พื้นฐาน",
      "full": "เต็มรูปแบบ",
      "paranoid": "เข้มงวดสูงสุด"
    },
    "permissions": {
      "title": "สิทธิ์เริ่มต้น",
      "titleWithName": "สิทธิ์เริ่มต้น — {{name}}",
      "subtitle": "บทบาทในหมวดหมู่นี้จะสืบทอดสิทธิ์เหล่านี้ เว้นแต่จะถูกปฏิเสธอย่างชัดเจน",
      "invalidCategoryId": "ID หมวดหมู่ไม่ถูกต้อง",
      "save": "บันทึกสิทธิ์เริ่มต้น",
      "cancel": "ยกเลิก",
      "toast": {
        "updatedSuccess": "อัปเดตสิทธิ์เริ่มต้นแล้ว",
        "saveError": "บันทึกสิทธิ์เริ่มต้นไม่สำเร็จ"
      }
    }
  },
  "permission": {
    "action": {
      "view": "ดู",
      "viewSelf": "ดูเฉพาะของตน",
      "viewRestricted": "ดูแบบจำกัด",
      "read": "อ่าน",
      "write": "เขียน",
      "create": "สร้าง",
      "update": "อัปเดต",
      "modify": "แก้ไข",
      "delete": "ลบ",
      "merge": "รวม",
      "discharge": "จำหน่ายผู้ป่วย",
      "transfer": "ย้าย",
      "approve": "อนุมัติ",
      "cosign": "ลงนามร่วม",
      "sign": "ลงนาม",
      "plan": "วางแผน",
      "manage": "จัดการ",
      "all": "ทั้งหมด",
      "breakGlass": "เข้าถึงฉุกเฉิน",
      "export": "ส่งออก",
      "amend": "แก้ไข",
      "administer": "ให้ยา",
      "doubleCheck": "ตรวจสอบซ้ำ",
      "reconcile": "ทบทวนยา",
      "verbalVerify": "ยืนยันคำสั่งวาจา",
      "verify": "ตรวจสอบ",
      "acknowledge": "รับทราบ",
      "prescribe": "สั่งยา",
      "dispense": "จ่ายยา",
      "cancel": "ยกเลิก",
      "users": "ผู้ใช้งาน",
      "roles": "บทบาท",
      "facilities": "สถานพยาบาล",
      "system": "ระบบ",
      "audit": "บันทึกการตรวจสอบ"
    }
  },
  "access": {
    "title": "เมทริกซ์สิทธิ์การเข้าถึง",
    "subtitle": "ตารางบทบาท × สิทธิ์",
    "searchPermission": "ค้นหาสิทธิ์…",
    "searchRole": "ค้นหาบทบาท…",
    "categoryFilter": "หมวดหมู่",
    "legend": {
      "own": "ของตนเอง",
      "inherited": "สืบทอด",
      "category": "หมวดหมู่",
      "denied": "ปฏิเสธ",
      "none": "ไม่มี"
    },
    "cellTooltip": {
      "hasOwn": "ได้รับโดยตรง",
      "hasInherited": "สืบทอดจากบทบาทแม่: {{source}}",
      "hasCategory": "ได้รับผ่านหมวดหมู่: {{source}}",
      "denied": "ปฏิเสธอย่างชัดเจน",
      "none": "ไม่ได้รับ"
    },
    "inheritedFrom": "สืบทอดจาก {{source}}",
    "bulkEdit": {
      "title": "แก้ไขจำนวนมาก",
      "applyTo": "ใช้กับรายการที่เลือก",
      "selectedPermissions": "{{count}} สิทธิ์",
      "selectedRoles": "{{count}} บทบาท",
      "actionGrant": "อนุญาต",
      "actionDeny": "ปฏิเสธ",
      "actionClear": "ล้าง",
      "save": "บันทึกการเปลี่ยนแปลง",
      "cancel": "ยกเลิก"
    },
    "emptyRoles": "ไม่มีบทบาทที่ตรงกับตัวกรอง",
    "emptyPermissions": "ไม่มีสิทธิ์ที่ตรงกับตัวกรอง",
    "loading": "กำลังโหลดเมทริกซ์สิทธิ์การเข้าถึง…",
    "permissionColumn": "สิทธิ์",
    "rolePicker": {
      "trigger": "เลือกบทบาทเพื่อเปรียบเทียบ",
      "filterPlaceholder": "กรองบทบาท…",
      "empty": "ไม่มีบทบาทที่ตรงกัน",
      "groupAll": "ทั้งหมด",
      "groupNone": "ไม่มี",
      "footerSummary": "เลือก {{count}} จาก {{total}}",
      "selectAll": "เลือกทั้งหมด",
      "clear": "ล้าง"
    },
    "empty": {
      "selectRolesPrompt": "เลือกบทบาทอย่างน้อยหนึ่งบทบาทเพื่อเปรียบเทียบ",
      "selectAllRoles": "เลือกบทบาททั้งหมด",
      "noPermissions": "ไม่พบสิทธิ์"
    },
    "legendCategoryDefault": "ค่าเริ่มต้นหมวดหมู่",
    "legendNotGranted": "ไม่ได้รับ",
    "page": {
      "title": "เมทริกซ์สิทธิ์การเข้าถึง",
      "subtitle": "ดูและจัดการบทบาท สิทธิ์ และนโยบายการเข้าถึง"
    },
    "tabs": {
      "matrix": "เมทริกซ์สิทธิ์การเข้าถึง",
      "roles": "การจัดการบทบาท",
      "categories": "การจัดการหมวดหมู่"
    },
    "roles": {
      "searchPlaceholder": "ค้นหาบทบาทหรือสิทธิ์...",
      "createButton": "สร้างบทบาท",
      "columns": {
        "role": "บทบาท",
        "category": "หมวดหมู่",
        "parent": "บทบาทแม่",
        "permissions": "สิทธิ์",
        "users": "ผู้ใช้งาน",
        "actions": "การดำเนินการ"
      },
      "systemBadge": "ระบบ",
      "managePermissionsTitle": "จัดการสิทธิ์",
      "manageDeniedTitle": "จัดการสิทธิ์ที่ถูกปฏิเสธ",
      "deniedBadge": "ปฏิเสธ",
      "editTitle": "แก้ไขบทบาท",
      "deleteTitle": "ลบบทบาท",
      "expandAria": "ขยายบทบาท",
      "collapseAria": "ยุบบทบาท",
      "effectivePermissions": "สิทธิ์ที่มีผล",
      "noPermissionsAssigned": "ไม่ได้กำหนดสิทธิ์ใด ๆ",
      "empty": "ไม่พบบทบาท",
      "delete": {
        "title": "ลบบทบาท",
        "description": "คุณแน่ใจหรือไม่ว่าต้องการลบบทบาท \"{{name}}\"? การกระทำนี้ไม่สามารถยกเลิกได้",
        "confirm": "ลบ"
      },
      "toast": {
        "deleted": "ลบบทบาทแล้ว",
        "deleteError": "ไม่สามารถลบบทบาทได้"
      }
    },
    "categories": {
      "subtitle": "หมวดหมู่จัดกลุ่มบทบาทและกำหนดนโยบายที่ใช้ร่วมกัน (MFA, การจำกัดเซสชัน)",
      "createButton": "สร้างหมวดหมู่",
      "requireMfa": "ต้องใช้ MFA",
      "yes": "ใช่",
      "no": "ไม่",
      "sessionTimeout": "หมดเวลาเซสชัน",
      "sessionTimeoutMinutes": "{{count}} นาที",
      "maxFailedLogins": "จำนวนครั้งเข้าสู่ระบบล้มเหลวสูงสุด",
      "manageDefaults": "จัดการสิทธิ์เริ่มต้น",
      "editTitle": "แก้ไข",
      "editAria": "แก้ไขหมวดหมู่",
      "deleteTitle": "ลบ",
      "deleteAria": "ลบหมวดหมู่",
      "empty": "ยังไม่มีหมวดหมู่ที่กำหนด",
      "delete": {
        "title": "ลบหมวดหมู่",
        "description": "คุณแน่ใจหรือไม่ว่าต้องการลบหมวดหมู่ \"{{name}}\"? การกระทำนี้ไม่สามารถยกเลิกได้",
        "confirm": "ลบ"
      },
      "toast": {
        "deleted": "ลบหมวดหมู่แล้ว",
        "deleteError": "ไม่สามารถลบหมวดหมู่ได้"
      }
    },
    "confirm": {
      "bulkApply": "ใช้การเปลี่ยนแปลง {{count}} รายการกับ {{roleCount}} บทบาท?",
      "discardChanges": "ยกเลิกการเปลี่ยนแปลงที่ยังไม่ได้บันทึก?"
    },
    "popover": {
      "grantTitle": "อนุญาตสิทธิ์",
      "denyTitle": "ปฏิเสธสิทธิ์",
      "clearTitle": "ล้างสิทธิ์",
      "grantNote": "การอนุญาตสิทธิ์นี้จะลบล้างการปฏิเสธที่สืบทอดมา",
      "denyNote": "การปฏิเสธสิทธิ์นี้จะลบล้างการอนุญาตที่สืบทอดมา",
      "clearNote": "การล้างจะคืนกลับเป็นพฤติกรรมที่สืบทอด"
    },
    "toast": {
      "permissionGranted": "อนุญาตสิทธิ์แล้ว",
      "permissionDenied": "ปฏิเสธสิทธิ์แล้ว",
      "permissionCleared": "ล้างสิทธิ์แล้ว",
      "bulkApplied": "ใช้การเปลี่ยนแปลงจำนวนมากแล้ว",
      "saveError": "บันทึกการเปลี่ยนแปลงไม่สำเร็จ"
    }
  },
  "confirm": {
    "restartIntegration": "รีสตาร์ท \"{{name}}\" หรือไม่ การเชื่อมต่อที่ใช้งานอยู่จะหลุดชั่วครู่ขณะโหลดวัสดุ TLS ใหม่",
    "revokeFhirEndpoint": "เพิกถอน \"{{name}}\" หรือไม่ การเรียกออกไปยังเอนด์พอยต์นี้จะหยุดลง",
    "rotateSmartSecret": "หมุนเวียน client secret สำหรับ \"{{name}}\" หรือไม่ secret เดิมจะหยุดทำงานทันที",
    "revokeSmartApp": "เพิกถอน \"{{name}}\" หรือไม่ คำขอโทเค็นในอนาคตจากแอปนี้จะล้มเหลว",
    "deactivateThirdPartyApp": "ปิดใช้งาน \"{{name}}\" หรือไม่"
  },
  "toast": {
    "tierCreated": "สร้างระดับแล้ว",
    "tierCloned": "โคลนระดับแล้ว",
    "tierDeleted": "ลบระดับแล้ว",
    "tierStatusUpdated": "อัปเดตสถานะแล้ว",
    "tierFeaturesUpdated": "อัปเดตคุณสมบัติแล้ว",
    "tierLimitsUpdated": "อัปเดตขีดจำกัดแล้ว",
    "tierSaveError": "สร้างระดับไม่สำเร็จ",
    "tierValidation": "ต้องระบุชื่อและรหัส",
    "licenseKeyGenerated": "สร้างคีย์ใบอนุญาตแล้ว",
    "licenseKeyCopied": "สร้างคีย์ใบอนุญาตและคัดลอกไปยังคลิปบอร์ดแล้ว",
    "overridesSaved": "บันทึกการแทนที่แล้ว",
    "pricingConfigSaved": "บันทึกการตั้งค่าแล้ว",
    "pricingPriceUpdated": "อัปเดตราคาแล้ว",
    "pricingRuleCreated": "สร้างกฎการกำหนดราคาแล้ว",
    "addonUpdated": "อัปเดตโมดูลเสริมแล้ว",
    "invalidNumber": "โปรดป้อนตัวเลขที่ถูกต้อง",
    "csvExported": "ส่งออก {{filename}} แล้ว",
    "integrationUpdated": "อัปเดตการเชื่อมต่อแล้ว",
    "integrationAdded": "เพิ่มการเชื่อมต่อแล้ว",
    "integrationInvalidConfig": "การกำหนดค่าไม่ถูกต้อง — ตรวจสอบโฮสต์/พอร์ตและฟิลด์ TLS",
    "integrationDuplicateName": "มีการเชื่อมต่อชื่อนี้อยู่แล้ว",
    "integrationSaveFailed": "บันทึกการเชื่อมต่อไม่สำเร็จ",
    "smartAppRegistered": "ลงทะเบียนแอป SMART แล้ว",
    "smartAppRegisterFailed": "ลงทะเบียนแอป SMART ไม่สำเร็จ",
    "smartAppUpdated": "อัปเดตแอป SMART แล้ว",
    "smartAppUpdateFailed": "อัปเดตแอป SMART ไม่สำเร็จ",
    "fhirEndpointUpdated": "อัปเดตเอนด์พอยต์แล้ว",
    "fhirEndpointRegistered": "ลงทะเบียนเอนด์พอยต์แล้ว",
    "fhirEndpointInvalidConfig": "การกำหนดค่าไม่ถูกต้อง — ตรวจสอบ base URL และฟิลด์ auth",
    "fhirEndpointDuplicateName": "มีเอนด์พอยต์ชื่อนั้นอยู่แล้ว",
    "fhirEndpointSaveFailed": "บันทึกเอนด์พอยต์ไม่สำเร็จ",
    "clientIdCopied": "คัดลอก Client ID แล้ว",
    "clientSecretCopied": "คัดลอก client secret แล้ว",
    "statusRefreshed": "รีเฟรชสถานะแล้ว",
    "connTestOk": "ทดสอบการเชื่อมต่อสำเร็จ",
    "connTestFailed": "ทดสอบการเชื่อมต่อล้มเหลว - ตรวจสอบการกำหนดค่าเอนด์พอยต์",
    "serverRestarted": "รีสตาร์ทเซิร์ฟเวอร์แล้ว — วัสดุ TLS ใหม่มีผลบังคับใช้",
    "clientReconnected": "ไคลเอนต์เชื่อมต่อใหม่แล้ว — วัสดุ TLS ใหม่มีผลบังคับใช้",
    "notRunning": "ไม่ทำงาน — เริ่มเซิร์ฟเวอร์/ไคลเอนต์เพื่อใช้การกำหนดค่า",
    "restartFailed": "รีสตาร์ทการเชื่อมต่อล้มเหลว",
    "metadataOk": "/metadata ปกติ{{detail}}",
    "metadataFailed": "/metadata ล้มเหลว: {{error}}",
    "metadataProbeFailed": "ตรวจสอบ /metadata ล้มเหลว",
    "metadataUnknownError": "ไม่ทราบ",
    "fhirRevoked": "เพิกถอนเอนด์พอยต์ FHIR แล้ว",
    "fhirRevokeFailed": "เพิกถอนเอนด์พอยต์ล้มเหลว",
    "smartRevoked": "เพิกถอนแอป SMART แล้ว",
    "smartRevokeFailed": "เพิกถอนแอป SMART ล้มเหลว",
    "secretRotated": "หมุนเวียนรหัสลับไคลเอนต์แล้ว",
    "rotateSecretFailed": "หมุนเวียนรหัสลับล้มเหลว",
    "messageRequeued": "จัดคิวข้อความใหม่เพื่อลองใหม่แล้ว",
    "messageRetryFailed": "ลองใหม่ล้มเหลว",
    "messageSkipped": "ข้ามข้อความแล้ว — คิวจะดำเนินต่อ",
    "messageSkipFailed": "ข้ามล้มเหลว",
    "messageAbandoned": "ละทิ้งข้อความแล้ว",
    "messageAbandonFailed": "ละทิ้งล้มเหลว",
    "messageResent": "ส่งข้อความใหม่เป็นข้อความใหม่แล้ว",
    "messageResendFailed": "ส่งใหม่ล้มเหลว",
    "reasonRequired": "ต้องระบุเหตุผล",
    "copiedToClipboard": "คัดลอกไปยังคลิปบอร์ดแล้ว",
    "thirdPartyAppCreated": "สร้างแอปบุคคลที่สามสำเร็จแล้ว",
    "thirdPartyAppUpdated": "อัปเดตแอปบุคคลที่สามสำเร็จแล้ว",
    "thirdPartyAppDeactivated": "ปิดใช้งานแอปบุคคลที่สามแล้ว",
    "thirdPartyAppLaunchUrl": "สร้าง URL การเปิดแล้ว: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "เพิ่มสถานพยาบาล",
      "editTitle": "แก้ไขสถานพยาบาล",
      "fields": {
        "name": "ชื่อ",
        "code": "รหัส",
        "type": "ประเภท",
        "address": "ที่อยู่",
        "city": "เมือง",
        "stateProvince": "จังหวัด/รัฐ",
        "country": "ประเทศ",
        "phone": "โทรศัพท์",
        "timeZone": "เขตเวลา",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "ตัวอย่าง: Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "ชื่อเขตเวลา IANA (ตัวอย่าง: Asia/Singapore) ใช้สำหรับวันที่ตามเวลาท้องถิ่นของสถานพยาบาลในสถิติผู้ป่วย, MAR และรายงาน"
      },
      "options": {
        "otherIana": "อื่น ๆ (IANA)…",
        "useCuratedList": "ใช้รายการที่แนะนำ"
      },
      "errors": {
        "nameMin": "ชื่อสถานพยาบาลต้องมีอย่างน้อย {{min}} ตัวอักษร",
        "codeFormat": "รหัสต้องเป็นตัวอักษรพิมพ์ใหญ่และตัวเลขเท่านั้น",
        "typeRequired": "ต้องระบุประเภทสถานพยาบาล",
        "countryRequired": "ต้องระบุประเทศ",
        "timeZoneRequired": "ต้องระบุเขตเวลา",
        "timeZoneInvalidIana": "เซิร์ฟเวอร์ปฏิเสธเขตเวลานี้ กรุณาใช้ชื่อ IANA ที่ถูกต้อง (ตัวอย่าง: Asia/Singapore)",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "สร้าง",
        "update": "อัปเดต"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างสถานพยาบาลสำเร็จ",
        "updatedSuccess": "อัปเดตสถานพยาบาลสำเร็จ",
        "saveError": "บันทึกสถานพยาบาลไม่สำเร็จ",
        "invalidTimeZone": "คำขอไม่ถูกต้อง — กรุณาตรวจสอบว่าเขตเวลาเป็นชื่อ IANA ที่ถูกต้อง (ตัวอย่าง: Asia/Singapore)"
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "การจัดการสถานพยาบาล",
      "subtitle": "สถานพยาบาล แผนก และ (ผ่านโครงสร้างต้นไม้นี้) ภาพรวมของลำดับชั้นที่ตั้งทางกายภาพ สำหรับโครงสร้างที่ตั้งแบบเต็ม (อาคาร → ชั้น → หน่วย → ห้อง → เตียง) ดูได้ที่ <locationsLink>ที่ตั้ง</locationsLink>",
      "columns": {
        "name": "ชื่อ",
        "code": "รหัส",
        "type": "ประเภท",
        "address": "ที่อยู่",
        "phone": "โทรศัพท์",
        "depts": "แผนก",
        "status": "สถานะ",
        "actions": "การดำเนินการ"
      },
      "filter": {
        "search": "ค้นหาสถานพยาบาล..."
      },
      "actions": {
        "new": "เพิ่มสถานพยาบาล",
        "editTitle": "แก้ไข"
      },
      "expand": {
        "expand": "ขยายสถานพยาบาล",
        "collapse": "ย่อสถานพยาบาล"
      },
      "empty": {
        "noMatch": "ไม่พบสถานพยาบาลที่ตรงกับการค้นหานั้น",
        "none": "ยังไม่มีสถานพยาบาล — คลิก เพิ่มสถานพยาบาล เพื่อเริ่มต้น"
      },
      "departments": {
        "title": "แผนก",
        "add": "เพิ่มแผนก",
        "empty": "ยังไม่ได้กำหนดแผนกใด ๆ",
        "locationsCount": "{{count}} ที่ตั้ง",
        "editTitle": "แก้ไขแผนก"
      },
      "locations": {
        "title": "ที่ตั้ง",
        "add": "เพิ่ม",
        "empty": "ไม่มีที่ตั้งในแผนกนี้ โครงสร้างที่ตั้ง (อาคาร → ชั้น → หน่วย → เตียง) จัดการที่ <locationsLink>ที่ตั้ง</locationsLink>"
      }
    },
    "type": {
      "generalHospital": "โรงพยาบาลทั่วไป",
      "teachingHospital": "โรงพยาบาลฝึกสอน",
      "specialtyHospital": "โรงพยาบาลเฉพาะทาง",
      "communityHospital": "โรงพยาบาลชุมชน",
      "clinic": "คลินิก"
    },
    "status": {
      "active": "ใช้งาน",
      "inactive": "ไม่ใช้งาน"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "เพิ่มระบบสุขภาพ",
      "editTitle": "แก้ไขระบบสุขภาพ",
      "subtitle": "ระดับบนสุดของโครงสร้างองค์กร เป็นองค์กรแม่ของสถานพยาบาลหนึ่งแห่งหรือมากกว่า",
      "sections": {
        "identity": "ข้อมูลพื้นฐาน",
        "primaryContact": "ผู้ติดต่อหลัก",
        "address": "ที่อยู่"
      },
      "fields": {
        "code": "รหัส",
        "name": "ชื่อ",
        "taxId": "เลขประจำตัวผู้เสียภาษี",
        "contactName": "ชื่อ-นามสกุล",
        "contactEmail": "อีเมล",
        "contactPhone": "โทรศัพท์",
        "addressLine1": "ที่อยู่บรรทัดที่ 1",
        "addressLine2": "ที่อยู่บรรทัดที่ 2",
        "city": "เมือง",
        "stateProvince": "จังหวัด/รัฐ",
        "postalCode": "รหัสไปรษณีย์",
        "country": "ประเทศ",
        "active": "ใช้งาน — ยกเลิกการเลือกเพื่อปิดใช้งาน"
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "ไม่สามารถแก้ไขรหัสได้หลังจากสร้างแล้ว"
      },
      "errors": {
        "codeRequired": "กรุณาระบุรหัส",
        "nameRequired": "กรุณาระบุชื่อ"
      },
      "submit": {
        "create": "สร้างระบบสุขภาพ",
        "update": "บันทึกการเปลี่ยนแปลง"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างระบบสุขภาพเรียบร้อยแล้ว",
        "updatedSuccess": "อัปเดตระบบสุขภาพเรียบร้อยแล้ว",
        "saveError": "ไม่สามารถบันทึกระบบสุขภาพได้",
        "codeConflict": "รหัสระบบนี้มีอยู่แล้ว",
        "invalidData": "ข้อมูลระบบสุขภาพไม่ถูกต้อง"
      }
    },
    "list": {
      "title": "ระบบสุขภาพ",
      "subtitle": "ระดับสูงสุดของโครงสร้างองค์กร — องค์กรแม่ประเภทเอ็นเตอร์ไพรซ์ / ระบบสุขภาพที่เป็นเจ้าของสถานพยาบาลหนึ่งแห่งขึ้นไป มักไม่เปลี่ยนแปลงหลังการตั้งค่าเริ่มต้น",
      "columns": {
        "name": "ชื่อ",
        "code": "รหัส",
        "contact": "ผู้ติดต่อ",
        "location": "ที่ตั้ง",
        "facilities": "สถานพยาบาล",
        "status": "สถานะ",
        "actions": "การดำเนินการ"
      },
      "filter": {
        "search": "ค้นหาตามชื่อหรือรหัส..."
      },
      "actions": {
        "new": "เพิ่มระบบสุขภาพ",
        "editTitle": "แก้ไข"
      },
      "status": {
        "active": "ใช้งาน",
        "inactive": "ไม่ใช้งาน"
      },
      "empty": {
        "noMatch": "ไม่พบระบบสุขภาพที่ตรงกับการค้นหานั้น",
        "none": "ยังไม่มีระบบสุขภาพ — คลิก เพิ่มระบบสุขภาพ เพื่อเริ่มต้น"
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "เพิ่มตำแหน่ง",
      "editTitle": "แก้ไขตำแหน่ง",
      "subtitle": "ตำแหน่งทางกายภาพ — อาคาร ชั้น หน่วย ห้อง หรือเตียง รองรับ FHIR R4 Location ซ้อนผ่านตำแหน่งหลักเพื่อสร้างแผนผังลำดับชั้น",
      "sections": {
        "hierarchy": "ลำดับชั้น",
        "identity": "การระบุ",
        "classification": "การจำแนก",
        "physicalAttributes": "คุณลักษณะทางกายภาพ"
      },
      "fields": {
        "facility": "สถานพยาบาล",
        "parentLocation": "ตำแหน่งหลัก",
        "department": "แผนก (ไม่บังคับ)",
        "code": "รหัส",
        "abbreviation": "อักษรย่อ",
        "name": "ชื่อ",
        "physicalType": "ประเภททางกายภาพ (FHIR)",
        "clinicalType": "ประเภททางคลินิก",
        "status": "สถานะ (FHIR)",
        "operationalStatus": "สถานะการใช้งาน (HL7 0116)",
        "building": "อาคาร",
        "floor": "ชั้น",
        "wing": "ปีก",
        "roomNumber": "หมายเลขห้อง",
        "bedIdentifier": "รหัสเตียง",
        "capacity": "ความจุ",
        "active": "ใช้งาน (ธงระบบเดิม)"
      },
      "placeholders": {
        "facility": "เลือกสถานพยาบาล…",
        "parentNone": "ไม่มี (ระดับบนสุด)",
        "departmentNone": "ไม่มี",
        "code": "4W-12-A",
        "name": "4W-12 เตียง A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "ชุดค่า FHIR LocationPhysicalType",
        "clinicalType": "ของเดิม จะเลิกใช้เมื่อ service_type พร้อม"
      },
      "physicalAttributes": {
        "show": "แสดง ▾",
        "hide": "ซ่อน ▴"
      },
      "errors": {
        "facilityRequired": "กรุณาเลือกสถานพยาบาล",
        "codeRequired": "กรุณาระบุรหัส",
        "nameRequired": "กรุณาระบุชื่อ"
      },
      "submit": {
        "create": "สร้างตำแหน่ง",
        "update": "บันทึกการเปลี่ยนแปลง"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างตำแหน่งเรียบร้อยแล้ว",
        "updatedSuccess": "อัปเดตตำแหน่งเรียบร้อยแล้ว",
        "saveError": "ไม่สามารถบันทึกตำแหน่งได้",
        "codeConflict": "รหัสตำแหน่งนี้มีอยู่แล้ว",
        "invalidData": "ข้อมูลตำแหน่งไม่ถูกต้อง"
      }
    },
    "list": {
      "title": "ลำดับชั้นสถานที่",
      "subtitle": "โครงสร้างทางกายภาพ: อาคาร → ชั้น → หน่วย → ห้อง → เตียง สอดคล้องกับ FHIR LocationPhysicalType คลิกป้ายสถานะเตียงเพื่อสลับสถานะการใช้งาน สถานพยาบาลและแผนกจัดการได้ใน <facilitiesLink>สถานพยาบาล</facilitiesLink>",
      "filter": {
        "search": "ค้นหาตามชื่อหรือรหัส...",
        "allFacilities": "ทุกสถานพยาบาล"
      },
      "actions": {
        "new": "เพิ่มสถานที่",
        "addChildTitle": "เพิ่มรายการย่อย",
        "editTitle": "แก้ไข"
      },
      "expand": {
        "expand": "ขยายสถานที่",
        "collapse": "ยุบสถานที่"
      },
      "bed": {
        "toggleTitle": "คลิกเพื่อสลับเป็น {{next}}"
      },
      "empty": {
        "noMatch": "ไม่มีสถานที่ที่ตรงกับการค้นหานั้น",
        "none": "สถานพยาบาลนี้ยังไม่มีสถานที่"
      },
      "toast": {
        "bedStatusUpdated": "อัปเดตสถานะเตียงแล้ว",
        "bedStatusError": "อัปเดตสถานะเตียงไม่สำเร็จ"
      }
    },
    "type": {
      "si": "พื้นที่",
      "bu": "อาคาร",
      "wi": "ปีกอาคาร",
      "wa": "หอผู้ป่วย",
      "lvl": "ชั้น",
      "co": "ทางเดิน",
      "ro": "ห้อง",
      "bd": "เตียง",
      "ve": "เสมือน",
      "ho": "บ้าน",
      "ca": "ตู้",
      "rd": "ถนน",
      "area": "พื้นที่",
      "jdn": "เขตอำนาจ"
    },
    "clinicalType": {
      "examRoom": "ห้องตรวจ",
      "inpatientBed": "เตียงผู้ป่วยใน",
      "procedureRoom": "ห้องหัตถการ",
      "icu": "ICU",
      "ed": "ห้องฉุกเฉิน",
      "or": "ห้องผ่าตัด",
      "virtual": "เสมือน"
    },
    "status": {
      "active": "ใช้งาน",
      "suspended": "ระงับ",
      "inactive": "ไม่ใช้งาน",
      "op": {
        "O": "มีผู้ใช้",
        "U": "ว่าง",
        "H": "ทำความสะอาด",
        "K": "ปนเปื้อน",
        "I": "แยกกัก",
        "C": "ปิด"
      }
    },
    "capability": {
      "isolation": "รองรับการแยกโรค",
      "negativePressure": "ความดันลบ",
      "bariatric": "รองรับผู้ป่วยน้ำหนักมาก",
      "telemetry": "รองรับการติดตามระยะไกล",
      "icu": "ระดับ ICU"
    }
  },
  "department": {
    "form": {
      "addTitle": "เพิ่มแผนก",
      "editTitle": "แก้ไขแผนก",
      "subtitle": "หน่วยขององค์กรภายในสถานพยาบาล สามารถซ้อนกันได้ (เช่น โรคหัวใจ → ห้องปฏิบัติการ EP) ผ่านแผนกแม่",
      "sections": {
        "department": "แผนก"
      },
      "fields": {
        "facility": "สถานพยาบาล",
        "code": "รหัส",
        "abbreviation": "ตัวย่อ",
        "name": "ชื่อ",
        "type": "ประเภท",
        "parentDepartment": "แผนกแม่",
        "costCenterCode": "รหัสศูนย์ต้นทุน",
        "revenueDepartmentCode": "รหัสแผนกรายได้",
        "active": "ใช้งาน — ยกเลิกการเลือกเพื่อปิดใช้งานอย่างนุ่มนวล"
      },
      "placeholders": {
        "facility": "เลือกสถานพยาบาล…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "โรคหัวใจ",
        "parentNone": "ไม่มี (ระดับบนสุด)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "ต้องระบุสถานพยาบาล",
        "codeRequired": "ต้องระบุรหัส",
        "nameRequired": "ต้องระบุชื่อ"
      },
      "submit": {
        "create": "สร้างแผนก",
        "update": "บันทึกการเปลี่ยนแปลง"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างแผนกสำเร็จ",
        "updatedSuccess": "อัปเดตแผนกสำเร็จ",
        "saveError": "บันทึกแผนกไม่สำเร็จ",
        "codeConflict": "รหัสแผนกนี้มีอยู่แล้ว",
        "invalidData": "ข้อมูลแผนกไม่ถูกต้อง"
      }
    },
    "serviceType": {
      "clinical": "คลินิก",
      "administrative": "บริหาร",
      "support": "สนับสนุน"
    },
    "status": {
      "active": "ใช้งาน",
      "inactive": "ไม่ใช้งาน"
    }
  },
  "provider": {
    "form": {
      "addTitle": "เพิ่มบุคลากรทางการแพทย์",
      "editTitle": "แก้ไขบุคลากรทางการแพทย์",
      "fields": {
        "fullName": "ชื่อ-นามสกุล",
        "npi": "NPI",
        "providerType": "ประเภทผู้ให้บริการ",
        "credentials": "คุณวุฒิ",
        "specialty": "สาขาเชี่ยวชาญ",
        "email": "อีเมล",
        "phone": "โทรศัพท์",
        "facilityAssignments": "การกำหนดสถานพยาบาล",
        "status": "สถานะ",
        "primaryFacility": "สถานพยาบาลหลัก",
        "loginAccount": "บัญชีเข้าสู่ระบบ"
      },
      "placeholders": {
        "specialty": "เลือกสาขาเชี่ยวชาญ…",
        "credentials": "เช่น MD, FACC",
        "providerType": "เลือกประเภทผู้ให้บริการ",
        "noLoginAccount": "ไม่มีบัญชีเข้าสู่ระบบ"
      },
      "submit": {
        "create": "สร้าง",
        "update": "อัปเดต"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างบุคลากรทางการแพทย์เรียบร้อย",
        "updatedSuccess": "อัปเดตบุคลากรทางการแพทย์เรียบร้อย",
        "saveError": "ไม่สามารถบันทึกบุคลากรทางการแพทย์"
      },
      "hints": {
        "loginAccount": "เชื่อมบุคลากรผู้นี้กับบัญชีที่ใช้เข้าสู่ระบบ หากไม่เชื่อม การลงนามร่วม การตรวจสอบโดยเภสัชกร และการรับทราบผลวิกฤตจะถูกปฏิเสธ"
      }
    },
    "list": {
      "title": "การจัดการผู้ให้บริการ",
      "subtitle": "จัดการผู้ให้บริการ คุณสมบัติ และการมอบหมายสถานพยาบาล",
      "columns": {
        "name": "ชื่อ",
        "npi": "NPI",
        "specialty": "สาขาความเชี่ยวชาญ",
        "credentials": "คุณสมบัติ",
        "facilities": "สถานพยาบาล",
        "status": "สถานะ",
        "actions": "การดำเนินการ"
      },
      "filter": {
        "search": "ค้นหาตามชื่อ, NPI, สาขาความเชี่ยวชาญ...",
        "allSpecialties": "ทุกสาขาความเชี่ยวชาญ",
        "allFacilities": "ทุกสถานพยาบาล",
        "allStatus": "ทุกสถานะ"
      },
      "actions": {
        "new": "เพิ่มผู้ให้บริการ",
        "editTitle": "แก้ไขผู้ให้บริการ",
        "scheduleTitle": "เทมเพลตตารางงาน",
        "viewCredentials": "ดูคุณสมบัติ"
      },
      "credentials": {
        "licenseLabel": "ใบอนุญาต",
        "none": "ไม่มีคุณสมบัติในระบบ"
      },
      "empty": "ไม่พบผู้ให้บริการ",
      "pagination": {
        "summary": "{{from}}-{{to}} จาก {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "หน้าก่อนหน้า",
        "next": "หน้าถัดไป"
      },
      "toast": {
        "schedulePlaceholder": "ลิงก์เทมเพลตตารางงาน (ตัวอย่าง)"
      },
      "noLogin": "ไม่มีบัญชี",
      "noLoginHint": "ผู้ให้บริการรายนี้ยังไม่ได้เชื่อมบัญชีเข้าสู่ระบบ จึงไม่สามารถลงนามร่วม ตรวจสอบ หรือรับทราบได้"
    },
    "specialty": {
      "internalMedicine": "อายุรศาสตร์",
      "cardiology": "อายุรศาสตร์โรคหัวใจ",
      "emergencyMedicine": "เวชศาสตร์ฉุกเฉิน",
      "pediatrics": "กุมารเวชศาสตร์",
      "pathology": "พยาธิวิทยา",
      "obstetricsGynecology": "สูติศาสตร์-นรีเวชวิทยา",
      "surgery": "ศัลยศาสตร์",
      "orthopedics": "ศัลยศาสตร์ออร์โธปิดิกส์",
      "neurology": "ประสาทวิทยา",
      "psychiatry": "จิตเวชศาสตร์",
      "radiology": "รังสีวิทยา",
      "anesthesiology": "วิสัญญีวิทยา",
      "oncology": "มะเร็งวิทยา",
      "dermatology": "ตจวิทยา",
      "ophthalmology": "จักษุวิทยา"
    },
    "status": {
      "active": "ปฏิบัติงาน",
      "inactive": "ไม่ใช้งาน",
      "onLeave": "ลาพัก"
    },
    "providerType": {
      "physician": "แพทย์",
      "nurse": "พยาบาล",
      "nursePractitioner": "พยาบาลเวชปฏิบัติ",
      "physicianAssistant": "ผู้ช่วยแพทย์",
      "pharmacist": "เภสัชกร",
      "therapist": "นักบำบัด",
      "technician": "เจ้าหน้าที่เทคนิค",
      "other": "อื่น ๆ",
      "midwife": "ผดุงครรภ์",
      "dentist": "ทันตแพทย์",
      "pharmacyTechnician": "ผู้ช่วยเภสัชกร",
      "careAssistant": "ผู้ช่วยพยาบาล",
      "dietitian": "นักโภชนาการ",
      "socialWorker": "นักสังคมสงเคราะห์",
      "traditionalMedicine": "แพทย์แผนดั้งเดิม"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "เพิ่มสายบริการ",
      "editTitle": "แก้ไขสายบริการ",
      "subtitle": "กลุ่มทางคลินิกระดับสูง (โรคหัวใจและหลอดเลือด, มะเร็งวิทยา) ที่เป็นต้นสังกัดของบริการทางคลินิกเฉพาะทาง",
      "sections": {
        "serviceLine": "สายบริการ"
      },
      "fields": {
        "healthSystem": "ระบบสุขภาพ",
        "code": "รหัส",
        "name": "ชื่อ",
        "description": "คำอธิบาย",
        "active": "ใช้งาน — ยกเลิกเครื่องหมายเพื่อปิดการใช้งานแบบ soft"
      },
      "placeholders": {
        "healthSystem": "เลือกระบบสุขภาพ…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "คำอธิบายสั้น — ขอบเขต, จุดเน้นของโรค, ฯลฯ"
      },
      "errors": {
        "healthSystemRequired": "ต้องระบุระบบสุขภาพ",
        "codeRequired": "ต้องระบุรหัส",
        "nameRequired": "ต้องระบุชื่อ"
      },
      "submit": {
        "create": "สร้างสายบริการ",
        "update": "บันทึกการเปลี่ยนแปลง"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างสายบริการแล้ว",
        "updatedSuccess": "อัปเดตสายบริการแล้ว",
        "saveError": "บันทึกสายบริการไม่สำเร็จ",
        "codeConflict": "รหัสสายบริการมีอยู่แล้ว",
        "invalidData": "ข้อมูลสายบริการไม่ถูกต้อง"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "เพิ่มบริการทางคลินิก",
      "editTitle": "แก้ไขบริการทางคลินิก",
      "subtitle": "บริการทางคลินิกเฉพาะทาง (หทัยวิทยา, ห้องปฏิบัติการ EP) จัดกลุ่มภายใต้สายบริการได้ตามต้องการ + กำกับด้วยรหัสสาขา NUCC สำหรับการเบิกค่ารักษา + การแสดงในสารบบ",
      "sections": {
        "clinicalService": "บริการทางคลินิก",
        "specialtyBilling": "สาขา + การเบิก"
      },
      "fields": {
        "code": "รหัส",
        "name": "ชื่อ",
        "serviceLine": "สายบริการ",
        "description": "คำอธิบาย",
        "specialtyCode": "รหัสสาขา NUCC",
        "specialtyDescription": "คำอธิบายสาขา",
        "revenueDepartmentCode": "รหัสแผนกรายได้",
        "active": "ใช้งาน"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— ไม่มี —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "อนุกรมวิธาน NUCC — ขับเคลื่อนสารบบผู้ให้บริการ + การแสดงข้อมูลในเอกสารเบิก"
      },
      "errors": {
        "codeRequired": "ต้องระบุรหัส",
        "nameRequired": "ต้องระบุชื่อ"
      },
      "submit": {
        "create": "สร้างบริการทางคลินิก",
        "update": "บันทึกการเปลี่ยนแปลง"
      },
      "cancel": "ยกเลิก",
      "toast": {
        "createdSuccess": "สร้างบริการทางคลินิกแล้ว",
        "updatedSuccess": "อัปเดตบริการทางคลินิกแล้ว",
        "saveError": "บันทึกบริการทางคลินิกไม่สำเร็จ",
        "codeConflict": "รหัสบริการทางคลินิกมีอยู่แล้ว",
        "invalidData": "ข้อมูลบริการทางคลินิกไม่ถูกต้อง"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "การกำหนดบริการ ↔ สถานที่",
    "subtitle": "บริการทางคลินิกใดดำเนินการในสถานที่จริงใด พร้อมช่วงวัน/เวลาและความจุที่เป็นทางเลือก การจัดตารางจะอ่านข้อมูลนี้เพื่อสร้างช่วงเวลาที่ว่าง ลบแบบนุ่มเท่านั้น — การสิ้นสุดการกำหนดจะเก็บประวัติไว้สำหรับรายงาน",
    "header": {
      "newAssignment": "การกำหนดใหม่",
      "toggleCancel": "ยกเลิก"
    },
    "form": {
      "title": "การกำหนดใหม่",
      "fields": {
        "service": "บริการทางคลินิก",
        "location": "สถานที่",
        "dayOfWeekPattern": "รูปแบบวันในสัปดาห์",
        "startTime": "เวลาเริ่ม",
        "endTime": "เวลาสิ้นสุด",
        "capacity": "ความจุ %",
        "notes": "หมายเหตุ",
        "isPrimary": "สถานที่หลักสำหรับบริการนี้"
      },
      "placeholders": {
        "service": "เลือกบริการ…",
        "location": "เลือกสถานที่…",
        "dayOfWeekPattern": "1,3,5 (จ./พ./ศ.)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "วัน ISO คั่นด้วยจุลภาค; ว่าง = ทุกวัน"
      },
      "errors": {
        "serviceLocationRequired": "ต้องระบุบริการและสถานที่"
      },
      "create": "สร้าง",
      "cancel": "ยกเลิก"
    },
    "filter": {
      "allFacilities": "ทุกสถานพยาบาล",
      "allServices": "ทุกบริการ",
      "allLocations": "ทุกสถานที่",
      "allStatuses": "ทุกสถานะ",
      "searchService": "ค้นหาบริการ…",
      "searchLocation": "ค้นหาสถานที่…",
      "facility": "สถานพยาบาล",
      "serviceLine": "สายบริการ"
    },
    "columns": {
      "service": "บริการ",
      "location": "สถานที่",
      "facility": "สถานพยาบาล",
      "when": "เมื่อใด",
      "capacity": "ความจุ",
      "effective": "มีผล",
      "status": "สถานะ",
      "actions": "การดำเนินการ"
    },
    "status": {
      "active": "ใช้งาน",
      "planned": "วางแผนไว้",
      "suspended": "ระงับ",
      "ended": "สิ้นสุด"
    },
    "dow": {
      "everyDay": "ทุกวัน",
      "monFri": "จ.–ศ.",
      "short": {
        "1": "จ.",
        "2": "อ.",
        "3": "พ.",
        "4": "พฤ.",
        "5": "ศ.",
        "6": "ส.",
        "7": "อา."
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "สถานที่หลัก",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "ตั้งเป็นหลัก",
      "unsetPrimary": "ยกเลิกการตั้งเป็นหลัก",
      "endAssignment": "สิ้นสุดการกำหนด"
    },
    "bulkEdit": {
      "title": "แก้ไขเป็นกลุ่ม",
      "applyTo": "นำไปใช้กับรายการที่เลือก",
      "selectedServices": "{{count}} บริการ",
      "selectedLocations": "{{count}} สถานที่",
      "save": "บันทึกการเปลี่ยนแปลง",
      "cancel": "ยกเลิก"
    },
    "confirm": {
      "endTitle": "สิ้นสุดการกำหนดหรือไม่?",
      "endDescription": "{{service}} → {{location}} การสิ้นสุดจะเก็บประวัติไว้แต่จะนำคู่นี้ออกจากการจัดตารางที่ใช้งานอยู่",
      "endConfirm": "สิ้นสุดการกำหนด",
      "removeService": "นำ {{service}} ออกจาก {{location}} หรือไม่?",
      "makePrimary": "ตั้งให้ {{location}} เป็นสถานที่หลักสำหรับ {{service}} หรือไม่?"
    },
    "toast": {
      "created": "สร้างการกำหนดแล้ว",
      "createError": "สร้างการกำหนดไม่สำเร็จ",
      "ended": "สิ้นสุดการกำหนดแล้ว",
      "endError": "สิ้นสุดการกำหนดไม่สำเร็จ",
      "primaryError": "สลับสถานที่หลักไม่สำเร็จ",
      "updated": "อัปเดตการกำหนดแล้ว"
    },
    "empty": "ไม่มีการกำหนดที่ตรงกับตัวกรองเหล่านี้ คลิก การกำหนดใหม่ เพื่อเพิ่ม"
  },
  "integration": {
    "list": {
      "title": "การจัดการการเชื่อมต่อ",
      "subtitle": "การเชื่อมต่อระบบ HL7, FHIR และบุคคลที่สาม",
      "refresh": "รีเฟรช",
      "addEndpoint": "เพิ่มเอนด์พอยต์",
      "searchPlaceholder": "ค้นหาการเชื่อมต่อ…",
      "tabs": {
        "endpoints": "เอนด์พอยต์",
        "messageLog": "บันทึกข้อความ",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "เอนด์พอยต์ทั้งหมด",
        "connected": "เชื่อมต่อแล้ว",
        "errors": "ข้อผิดพลาด",
        "totalMessages": "ข้อความทั้งหมด"
      }
    },
    "columns": {
      "status": "สถานะ",
      "name": "ชื่อ",
      "type": "ประเภท",
      "direction": "ทิศทาง",
      "url": "URL",
      "tls": "TLS",
      "auth": "การยืนยันตัวตน",
      "lastMessage": "ข้อความล่าสุด",
      "messages": "ข้อความ",
      "errors": "ข้อผิดพลาด",
      "backlog": "งานค้าง",
      "health": "สถานะสุขภาพ",
      "actions": "การดำเนินการ",
      "backlogTitle": "ข้อความขาออกที่รอดำเนินการ + อายุของรายการที่รอนานที่สุด",
      "healthTitle": "สถานะสุขภาพ — สีแดงหากคิวถูกบล็อกด้วยข้อความที่ล้มเหลว"
    },
    "badge": {
      "tlsCerts": "ใบรับรอง: {{cert}}, คีย์: {{key}}, CA: {{ca}}",
      "yes": "ใช่",
      "no": "ไม่",
      "basicTitle": "basic ({{username}})",
      "bearerStored": "จัดเก็บโทเค็น Bearer แล้ว",
      "bearerNoToken": "bearer (ยังไม่ได้ตั้งค่าโทเค็น)",
      "mtlsCert": "ใบรับรองไคลเอนต์ mTLS",
      "awaitingAck": "{{n}} รายการรอ ACK",
      "oldest": "เก่าสุด {{age}}",
      "never": "ไม่เคย",
      "blocked": "ถูกบล็อก",
      "waiting": "กำลังรอ",
      "ok": "ปกติ",
      "blockedTitle": "ข้อความที่ล้มเหลวกำลังบล็อกคิวของการเชื่อมต่อนี้ คลิกเพื่อเปิดบันทึกที่กรองแล้ว",
      "waitingTitle": "ข้อความกำลังรอ ACK แอปโหมดขั้นสูงจากพาร์ทเนอร์ คลิกเพื่อเปิดบันทึกที่กรองแล้ว",
      "okTitle": "ทุกอย่างปกติ — คลิกเพื่อเปิดบันทึกข้อความของการเชื่อมต่อนี้",
      "receives": "รับ"
    },
    "action": {
      "testConnection": "ทดสอบการเชื่อมต่อ",
      "restartTls": "รีสตาร์ท — ใช้ TLS ที่เพิ่งหมุนเวียน",
      "investigate": "ทรูพุต เวลาหน่วง และความล้มเหลวล่าสุด",
      "edit": "แก้ไข"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "50 ข้อความล่าสุด",
      "columns": {
        "time": "เวลา",
        "id": "ID",
        "direction": "ทิศทาง",
        "type": "ประเภท",
        "source": "แหล่งที่มา",
        "summary": "สรุป",
        "status": "สถานะ"
      },
      "dir": {
        "in": "เข้า",
        "out": "ออก"
      }
    },
    "fhir": {
      "serverStatusHeader": "สถานะเซิร์ฟเวอร์ FHIR R4",
      "serverOnline": "เซิร์ฟเวอร์ออนไลน์",
      "supportedResources": "ทรัพยากรที่รองรับ",
      "version": "เวอร์ชัน",
      "externalHeader": "เอนด์พอยต์ FHIR ภายนอก",
      "registerEndpoint": "ลงทะเบียนเอนด์พอยต์",
      "columns": {
        "name": "ชื่อ",
        "baseUrl": "URL ฐาน",
        "auth": "การยืนยันตัวตน",
        "status": "สถานะ",
        "lastChecked": "ตรวจสอบล่าสุด",
        "actions": "การดำเนินการ"
      },
      "emptyEndpoints": "ยังไม่มีเอนด์พอยต์ FHIR ภายนอกที่ลงทะเบียน",
      "revoked": "เพิกถอนแล้ว",
      "statusOk": "ปกติ",
      "statusError": "ข้อผิดพลาด",
      "testMetadata": "ทดสอบ /metadata",
      "edit": "แก้ไข",
      "revoke": "เพิกถอน"
    },
    "smart": {
      "header": "แอป SMART ที่ลงทะเบียน",
      "registerApp": "ลงทะเบียนแอป",
      "columns": {
        "appName": "ชื่อแอป",
        "clientId": "Client ID",
        "scopes": "ขอบเขต",
        "status": "สถานะ",
        "lastModified": "แก้ไขล่าสุด",
        "actions": "การดำเนินการ"
      },
      "emptyApps": "ยังไม่มีแอป SMART ที่ลงทะเบียน",
      "edit": "แก้ไข",
      "rotateSecret": "หมุนเวียนรหัสลับไคลเอนต์",
      "revoke": "เพิกถอน"
    },
    "secretModal": {
      "title": "โปรดบันทึก client secret นี้ทันที",
      "body": "secret นี้จะแสดงเพียงครั้งเดียว หากสูญหาย โปรดหมุนเวียน secret เพื่อออกใหม่",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "คัดลอก Client ID",
      "copyClientSecret": "คัดลอก Client Secret",
      "saved": "ฉันบันทึกแล้ว"
    },
    "drawer": {
      "header": "การเชื่อมต่อ #{{id}}",
      "refresh": "รีเฟรช",
      "close": "ปิด",
      "queueBlocked": "คิวถูกบล็อก",
      "queueBlockedBody": "ข้อความที่ล้มเหลวกำลังทำให้การเชื่อมต่อนี้ส่งไม่ได้ ข้อความที่อยู่ถัดไปจะรอจนกว่าผู้ปฏิบัติงานจะดำเนินการ",
      "investigate": "ตรวจสอบ",
      "tiles": {
        "backlog": "งานค้าง",
        "success24h": "สำเร็จ 24h",
        "avgLatency24h": "เวลาหน่วงเฉลี่ย 24h",
        "awaitingAck": "รอ app-ACK"
      },
      "charts": {
        "throughput": "ปริมาณงาน (24h)",
        "throughputSub": "ช่วงรายชั่วโมง ซ้อนกัน: ขาออกสำเร็จ + ล้มเหลว; ขาเข้าบนแกนรอง",
        "successRate": "อัตราความสำเร็จ (24h)",
        "successRateSub": "ต่อช่วง: สำเร็จ / (สำเร็จ + ล้มเหลว) ช่องว่างคือช่วงที่ไม่มีงาน",
        "ackLatency": "เวลาหน่วง ACK (24h)",
        "ackLatencySub": "เวลาระหว่างการส่งและได้รับ ACK avg เป็นเส้นทึบ p95 เป็นเส้นประ"
      },
      "series": {
        "outCompleted": "ขาออก · สำเร็จ",
        "outFailed": "ขาออก · ล้มเหลว",
        "inReceived": "ขาเข้า · รับแล้ว",
        "successPct": "สำเร็จ %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "ความล้มเหลวล่าสุด",
      "viewAll": "ดูทั้งหมด →",
      "noFailures": "ไม่มีข้อความที่ล้มเหลวในช่วงล่าสุด 🎉"
    }
  },
  "integrationStatus": {
    "connected": "เชื่อมต่อแล้ว",
    "disconnected": "ตัดการเชื่อมต่อ",
    "error": "ข้อผิดพลาด"
  },
  "integrationDirection": {
    "server": "เซิร์ฟเวอร์",
    "client": "ไคลเอนต์"
  },
  "messageStatus": {
    "sent": "ส่งแล้ว",
    "received": "ได้รับแล้ว",
    "error": "ข้อผิดพลาด",
    "acknowledged": "ยืนยันแล้ว"
  },
  "smartAppStatus": {
    "active": "ใช้งาน",
    "revoked": "เพิกถอนแล้ว"
  },
  "interfaceMessageStatus": {
    "pending": "รอดำเนินการ",
    "processing": "กำลังประมวลผล",
    "completed": "เสร็จสมบูรณ์",
    "received": "ได้รับแล้ว",
    "processed": "ประมวลผลแล้ว",
    "failed": "ล้มเหลว",
    "error": "ข้อผิดพลาด",
    "rejected": "ถูกปฏิเสธ",
    "deadLetter": "เดดเลตเตอร์",
    "skipped": "ข้ามแล้ว",
    "awaitingAppAck": "รอ ACK จากแอป"
  },
  "interfaceDirection": {
    "in": "ขาเข้า",
    "out": "ขาออก"
  },
  "attemptOutcome": {
    "sent": "ส่งแล้ว",
    "appNak": "App NAK",
    "timeout": "หมดเวลา",
    "networkError": "ข้อผิดพลาดเครือข่าย"
  },
  "fhirEndpoint": {
    "titleEdit": "แก้ไขเอนด์พอยต์ FHIR",
    "titleRegister": "ลงทะเบียนเอนด์พอยต์ FHIR",
    "subtitle": "พาร์ทเนอร์ FHIR R4 ภายนอกที่เกตเวย์ติดต่อแบบ outbound ปุ่ม Test Connection ในรายการการเชื่อมต่อจะตรวจ <code>/metadata</code> ด้วย auth + TLS ที่กำหนดไว้",
    "back": "กลับ",
    "cancel": "ยกเลิก",
    "storedBlank": "จัดเก็บแล้ว — เว้นว่างไว้เพื่อคงค่าเดิม",
    "save": {
      "changes": "บันทึกการเปลี่ยนแปลง",
      "register": "ลงทะเบียนเอนด์พอยต์"
    },
    "section": {
      "basics": "พื้นฐาน",
      "auth": "การยืนยันตัวตน",
      "tls": "TLS"
    },
    "fields": {
      "name": "ชื่อ",
      "baseUrl": "Base URL",
      "description": "คำอธิบาย",
      "active": "ใช้งาน — ยกเลิกการเลือกเพื่อ soft-revoke",
      "method": "วิธี",
      "username": "ชื่อผู้ใช้",
      "password": "รหัสผ่าน",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "ต้องใช้ https:// (รับ http://localhost สำหรับการพัฒนา) /metadata ต่อท้ายจะถูกเพิ่มอัตโนมัติระหว่าง Test",
      "oauth2": "การดึงโทเค็น OAuth2 เชื่อมต่อแล้วฝั่งผู้ดูแล ตัวดึงรันไทม์จะมาในรอบถัดไป สำหรับตอนนี้ ให้กรอกค่าและรัน Test เพื่อตรวจสอบการกำหนดค่าที่เหลือ",
      "tls": "วาง root CA เพื่อปักหมุดใบรับรองเซิร์ฟเวอร์ของพาร์ทเนอร์ หรือวาง client cert + key สำหรับ mTLS CA เพียงอย่างเดียวใช้งานได้กับ root store ของระบบสำหรับ CA ที่รู้จักกันดี"
    },
    "option": {
      "method": {
        "none": "ไม่มี",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — ไม่บังคับสำหรับพาร์ทเนอร์ส่วนใหญ่",
      "clientCertRequired": "Client certificate (PEM) — จำเป็น",
      "clientCertMtls": "Client certificate (PEM) — สำหรับ mTLS",
      "clientKeyRequired": "Client private key (PEM) — จำเป็น",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "ต้องระบุชื่อ",
      "baseUrlRequired": "ต้องระบุ Base URL",
      "baseUrlInvalid": "URL หลักต้องเป็น URL http(s) ที่ถูกต้อง",
      "basicUsername": "Basic auth ต้องมีชื่อผู้ใช้",
      "basicPassword": "Basic auth ต้องมีรหัสผ่าน",
      "bearerToken": "Bearer auth ต้องมี token",
      "clientCertKey": "Client-certificate auth ต้องมี cert + key"
    }
  },
  "smartApp": {
    "titleEdit": "แก้ไขแอป SMART",
    "titleRegister": "ลงทะเบียนแอป SMART",
    "subtitle": "การลงทะเบียนไคลเอนต์ SMART on FHIR ระบบจะสร้าง client ID ให้คุณ ส่วน client secret จะแสดงเพียงครั้งเดียวหลังการสร้างหรือหมุนเวียน",
    "back": "กลับ",
    "cancel": "ยกเลิก",
    "save": "บันทึกการเปลี่ยนแปลง",
    "register": "ลงทะเบียน",
    "fields": {
      "appName": "ชื่อแอป",
      "redirectUris": "Redirect URI",
      "scopes": "ขอบเขต (scope)",
      "launchUrl": "URL สำหรับเปิดใช้งาน",
      "logoUrl": "URL โลโก้",
      "active": "ใช้งาน — ยกเลิกการเลือกเพื่อเพิกถอนแบบซอฟต์สำหรับแอปนี้"
    },
    "placeholder": {
      "appName": "ตัวเปิดใช้งาน EHR ของฉัน"
    },
    "helper": {
      "redirectUris": "หนึ่ง URI ต่อหนึ่งบรรทัด ต้องใช้ https:// (ระหว่างพัฒนาก็รองรับ http://localhost ด้วย)"
    },
    "secretModal": {
      "title": "โปรดบันทึก client secret นี้ทันที",
      "body": "secret นี้จะแสดงเพียงครั้งเดียว หากสูญหาย โปรดหมุนเวียน secret เพื่อออกใหม่",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "คัดลอก Client ID",
      "copyClientSecret": "คัดลอก Client Secret",
      "saved": "ฉันบันทึกแล้ว"
    },
    "validation": {
      "nameRequired": "ต้องระบุชื่อ",
      "redirectUriRequired": "ต้องมี redirect URI อย่างน้อยหนึ่งรายการ",
      "scopeRequired": "ต้องมีขอบเขต (scope) อย่างน้อยหนึ่งรายการ"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "บันทึกข้อความอินเทอร์เฟซ",
      "subtitle": "ข้อความ HL7 ขาเข้า + ขาออกจากทุกการเชื่อมต่อที่ใช้งานอยู่",
      "refresh": "รีเฟรช",
      "loading": "กำลังโหลดข้อความ…",
      "empty": "ไม่มีข้อความที่ตรงกับตัวกรองปัจจุบัน",
      "pagination": "{{total}} ข้อความ • หน้า {{page}} จาก {{pages}}",
      "prev": "ก่อนหน้า",
      "next": "ถัดไป",
      "archived": "(จัดเก็บ)"
    },
    "relative": {
      "secondsAgo": "{{n}} วินาทีที่แล้ว",
      "minutesAgo": "{{n}} นาทีที่แล้ว",
      "hoursAgo": "{{n}} ชั่วโมงที่แล้ว"
    },
    "filter": {
      "header": "ตัวกรอง",
      "direction": "ทิศทาง",
      "status": "สถานะ",
      "messageType": "ประเภทข้อความ",
      "msh10": "MSH-10 ที่มี",
      "integrationId": "รหัสการเชื่อมต่อ",
      "includeArchive": "รวมที่จัดเก็บถาวร",
      "clear": "ล้างตัวกรอง",
      "any": "ใดก็ได้",
      "messageTypePlaceholder": "เช่น ADT^A01",
      "controlIdPlaceholder": "รหัสควบคุม"
    },
    "columns": {
      "id": "ID",
      "dir": "ทิศ",
      "integ": "เชื่อมต่อ",
      "type": "ประเภท",
      "msh10": "MSH-10",
      "status": "สถานะ",
      "ack": "ACK",
      "attempts": "ครั้งที่ลอง",
      "when": "เมื่อ"
    },
    "detail": {
      "eyebrow": "ข้อความ{{direction}}",
      "close": "ปิด",
      "loading": "กำลังโหลด…",
      "tabs": {
        "overview": "ภาพรวม",
        "rawHl7": "HL7 ดิบ",
        "attempts": "ความพยายาม"
      },
      "operatorActions": "การดำเนินการของผู้ปฏิบัติงาน",
      "retry": "ลองใหม่",
      "skip": "ข้าม",
      "abandon": "ละทิ้ง",
      "resendAsNew": "ส่งใหม่เป็นข้อความใหม่",
      "skipReason": "เหตุผลในการข้าม",
      "abandonReason": "เหตุผลในการละทิ้ง",
      "actionsHelper": "การดำเนินการจะถูกตรวจสอบพร้อม ID ผู้ใช้ + เหตุผล การข้ามและการละทิ้งต้องระบุเหตุผล",
      "overview": {
        "direction": "ทิศทาง",
        "integration": "การเชื่อมต่อ",
        "type": "ประเภท",
        "msh10": "MSH-10",
        "status": "สถานะ",
        "ackCode": "รหัส ACK",
        "attempts": "ความพยายาม",
        "created": "สร้างเมื่อ",
        "ackReceived": "ได้รับ ACK",
        "nextRetry": "ลองใหม่ครั้งถัดไป",
        "ackText": "ข้อความ ACK",
        "lastError": "ข้อผิดพลาดล่าสุด",
        "sourceEventId": "ID เหตุการณ์ต้นทาง"
      },
      "rawViewer": {
        "permissionDenied": "HL7 ดิบที่ถอดรหัสแล้วต้องใช้สิทธิ์ <code>INTERFACE_OPERATE</code>",
        "notAvailable": "ไม่มี payload ดิบสำหรับข้อความนี้",
        "bytes": "{{bytes}} ไบต์",
        "copy": "คัดลอก"
      },
      "attempts": {
        "inboundInfo": "ประวัติความพยายามจะถูกติดตามสำหรับข้อความขาออกเท่านั้น ข้อความขาเข้าจะถูกประมวลผลครั้งเดียวต่อ MSH-10 การส่งซ้ำจะคืนค่า ACK ที่แคชไว้โดยไม่มีความพยายามใหม่",
        "totalAttempts": "ความพยายามทั้งหมด",
        "nextAt": " (ครั้งถัดไปที่ {{time}})",
        "refresh": "รีเฟรช",
        "loading": "กำลังโหลดความพยายาม…",
        "error": "โหลดความพยายามล้มเหลว",
        "empty": "ยังไม่มีการบันทึกความพยายาม เวิร์กเกอร์เขียนหนึ่งแถวต่อการส่ง รายการนี้จะถูกเติมหลังการอ้างสิทธิ์ครั้งแรก",
        "columns": {
          "when": "เมื่อ",
          "outcome": "ผลลัพธ์",
          "ack": "ACK",
          "duration": "ระยะเวลา",
          "detail": "รายละเอียด"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "แอปพลิเคชันบุคคลที่สาม",
      "subtitle": "กำหนดค่าแอปพลิเคชันภายนอกที่สามารถเปิดจาก VynaEMR พร้อมบริบทผู้ป่วย",
      "addApp": "เพิ่มแอปพลิเคชัน",
      "searchPlaceholder": "ค้นหาแอปตามชื่อ รหัส หรือหมวดหมู่...",
      "emptyTitle": "ไม่มีแอปพลิเคชันที่กำหนดค่า",
      "emptyBody": "เพิ่มแอปพลิเคชันภายนอก เช่น โปรแกรมดู PACS พอร์ทัลห้องแล็บ หรือระบบเภสัชกรรม",
      "columns": {
        "application": "แอปพลิเคชัน",
        "category": "หมวดหมู่",
        "url": "URL",
        "security": "ความปลอดภัย",
        "display": "การแสดงผล",
        "status": "สถานะ",
        "actions": "การดำเนินการ"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "ลงนาม JWT แล้ว",
      "hmac": "HMAC",
      "hmacSigned": "ลงนาม HMAC แล้ว",
      "none": "ไม่มี",
      "chart": "แผนภูมิ",
      "sidebar": "แถบด้านข้าง",
      "active": "ใช้งาน",
      "inactive": "ไม่ใช้งาน"
    },
    "action": {
      "testLaunch": "ทดสอบการเปิด",
      "edit": "แก้ไข",
      "deactivate": "ปิดใช้งาน"
    },
    "form": {
      "titleEdit": "แก้ไขแอปพลิเคชัน",
      "titleNew": "แอปพลิเคชันใหม่",
      "fields": {
        "appCode": "รหัสแอป",
        "appName": "ชื่อแอป",
        "category": "หมวดหมู่",
        "baseUrl": "URL พื้นฐาน",
        "launchMethod": "วิธีการเปิด",
        "paramMappings": "การแมปพารามิเตอร์",
        "enableJwt": "เปิดใช้การลงนามโทเค็น JWT",
        "sharedSecret": "รหัสลับที่ใช้ร่วมกัน (คีย์ลงนาม JWT)",
        "enableHmac": "เปิดใช้ลายเซ็น URL (HMAC)",
        "hmacKey": "คีย์ HMAC",
        "requiredPermission": "สิทธิ์ที่จำเป็น",
        "displayOrder": "ลำดับการแสดงผล",
        "showInChart": "แสดงในแผนภูมิ",
        "showInSidebar": "แสดงในแถบด้านข้าง"
      },
      "placeholder": {
        "appCode": "เช่น pacs_viewer",
        "appName": "เช่น PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "ชื่อพารามิเตอร์ URL",
        "unchanged": "(ไม่เปลี่ยนแปลง)",
        "sharedSecret": "ป้อนรหัสลับที่ใช้ร่วมกัน",
        "hmacKey": "ป้อนคีย์ HMAC",
        "requiredPermission": "เช่น RESULT_VIEW (เว้นว่าง = ผู้ใช้ใดก็ได้)"
      },
      "addParameter": "เพิ่มพารามิเตอร์",
      "cancel": "ยกเลิก",
      "submitUpdate": "อัปเดตแอปพลิเคชัน",
      "submitCreate": "สร้างแอปพลิเคชัน"
    },
    "paramSource": {
      "patientMrn": "MRN ผู้ป่วย",
      "patientName": "ชื่อผู้ป่วย",
      "patientDob": "DOB ผู้ป่วย",
      "encounterId": "ID การพบแพทย์",
      "encounterNumber": "หมายเลขการพบแพทย์",
      "orderNumber": "หมายเลขคำสั่ง",
      "userName": "ชื่อผู้ใช้ปัจจุบัน",
      "userId": "ID ผู้ใช้ปัจจุบัน",
      "timestamp": "การประทับเวลาปัจจุบัน"
    },
    "launch": "เปิด {{name}}"
  },
  "integrationForm": {
    "titleEdit": "แก้ไขการเชื่อมต่อ",
    "titleAdd": "เพิ่มการเชื่อมต่อ",
    "subtitle": "อินเทอร์เฟซ MLLP และ HL7-over-HTTP ที่รองรับด้วย VynaHL7 ข้อมูลใบรับรองถูกจัดเก็บในระเบียนการเชื่อมต่อ การหมุนเวียนจะมีผลในครั้งถัดไปที่รีสตาร์ตเซิร์ฟเวอร์หรือไคลเอ็นต์",
    "back": "กลับ",
    "cancel": "ยกเลิก",
    "saveChanges": "บันทึกการเปลี่ยนแปลง",
    "addIntegration": "เพิ่มการเชื่อมต่อ",
    "storedBlank": "จัดเก็บแล้ว — เว้นว่างไว้เพื่อคงไว้",
    "selectSibling": "— เลือกการเชื่อมต่อระดับเดียวกัน —",
    "section": {
      "basics": "ข้อมูลพื้นฐาน",
      "connection": "การเชื่อมต่อ",
      "tls": "TLS / mTLS",
      "auth": "การยืนยันตัวตน",
      "ackDelivery": "การตอบรับและการส่งมอบ",
      "outboundRouting": "การกำหนดเส้นทางขาออก",
      "inboundTrust": "ความเชื่อถือขาเข้า"
    },
    "fields": {
      "name": "ชื่อ",
      "type": "ประเภท",
      "direction": "ทิศทาง",
      "description": "คำอธิบาย",
      "active": "ใช้งาน — ยกเลิกการเลือกเพื่อปิดอินเทอร์เฟซนี้แบบซอฟต์",
      "host": "โฮสต์",
      "port": "พอร์ต",
      "enableTls": "เปิดใช้ TLS — ใช้",
      "serverCert": "ใบรับรองเซิร์ฟเวอร์ (PEM)",
      "clientCert": "ใบรับรองไคลเอ็นต์ (PEM) — ทางเลือกสำหรับ mTLS",
      "serverKey": "คีย์ส่วนตัวเซิร์ฟเวอร์ (PEM)",
      "clientKey": "คีย์ส่วนตัวไคลเอ็นต์ (PEM)",
      "serverCa": "ที่เก็บความเชื่อถือ CA ไคลเอ็นต์ (PEM) — สำหรับ mTLS",
      "clientCa": "ที่เก็บความเชื่อถือ CA เซิร์ฟเวอร์ (PEM) — ทางเลือก สำรองไปยังรากของระบบ",
      "method": "วิธีการ",
      "username": "ชื่อผู้ใช้",
      "password": "รหัสผ่าน",
      "bearerToken": "โทเค็น Bearer",
      "inboundAck": "นโยบาย ACK ขาเข้า",
      "outboundAck": "นโยบาย ACK ขาออก",
      "processingTimeout": "หมดเวลาประมวลผล (มิลลิวินาที)",
      "pendingAckTtl": "TTL ACK ที่รอดำเนินการ (วินาที)",
      "networkRetry": "จำนวนลองใหม่เครือข่ายสูงสุด",
      "appNakRetry": "จำนวนลองใหม่ NAK แอปสูงสุด",
      "reverseIntegration": "การเชื่อมต่อช่องทางย้อนกลับ",
      "outboundTypes": "ประเภทข้อความที่รับ",
      "outboundEvents": "การสมัครรับระดับเหตุการณ์",
      "receivingApplication": "แอปพลิเคชันผู้รับ (MSH-5)",
      "receivingFacility": "สถานพยาบาลผู้รับ (MSH-6)",
      "inboundTrustProfile": "พันธมิตรรายนี้สามารถ"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "บันทึกสั้น ๆ เกี่ยวกับอินเทอร์เฟซนี้ — เจ้าของ วัตถุประสงค์ ประเภทข้อความ ฯลฯ",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "ที่อยู่สำหรับผูก ใช้ 0.0.0.0 เพื่อรับฟังบนทุกอินเทอร์เฟซ",
      "hostClient": "โฮสต์ระยะไกลที่ไคลเอ็นต์นี้ควรเชื่อมต่อไป",
      "tlsHandshake": "สำหรับการแฮนด์เชค",
      "authClientCert": "ใบรับรอง/คีย์ไคลเอ็นต์มาจากส่วน TLS ด้านบน",
      "authNone": "ไม่แนบส่วนหัวการยืนยันตัวตน HTTP",
      "authRs7": "{{call}} จะเชื่อมต่อสิ่งนี้เข้ากับทุกคำขอขาออก",
      "ackDefaults": "ควบคุมวิธีที่เกตเวย์ ACK ข้อความ HL7 ขาเข้า และวิธีตีความ ACK ตอบกลับเมื่อส่งออก ค่าเริ่มต้น",
      "ackDefaultsTail": "ตรงกับพฤติกรรมก่อน 0.19.0 — เปลี่ยนแปลงตามพาร์ตเนอร์แต่ละรายตามต้องการ",
      "processingTimeout": "ขีดจำกัดสำหรับการประมวลผลแบบอินไลน์ของ ACK แอปแบบซิงค์ หมดเวลา → AE + ลองคิวเบื้องหลังอีกครั้ง",
      "pendingAckTtl": "เวลารอ ACK แอปในโหมดขั้นสูงก่อนที่ตัวกวาดจะหมดเวลา",
      "networkRetry": "จำนวนการลองใหม่สำหรับข้อผิดพลาดการส่งก่อนที่คิวจะถูกบล็อก",
      "appNakRetry": "จำนวนการลองใหม่สำหรับ AE/AR/CE/CR — โดยทั่วไป 2–3 ครั้ง เนื่องจากเพย์โหลดเดิมแทบไม่สำเร็จเมื่อลองใหม่",
      "reverse": "โหมดขั้นสูงส่ง ACK แอปจริงผ่านการเชื่อมต่อระดับเดียวกันที่ชี้ไปยังปลายทางย้อนกลับของพาร์ตเนอร์ สร้างการเชื่อมต่อระดับเดียวกันเป็นระเบียนแยกก่อน แล้วเชื่อมโยงที่นี่",
      "outboundRouting": "สิ่งที่คู่ค้ารายนี้จะได้รับ หากไม่เลือกอะไรเลย อินเทอร์เฟซนี้จะไม่ใช่ปลายทางขาออกและจะไม่มีข้อความใดถูกส่งไป",
      "outboundEvents": "ไม่บังคับ คั่นด้วยจุลภาค แคบกว่าทั้งประเภท — สำหรับคู่ค้าที่ต้องการเฉพาะบางเหตุการณ์",
      "receivingDefaults": "MSH-5 และ MSH-6 ระบุผู้รับในทุกข้อความที่ส่งมาที่นี่ เว้นว่างไว้เพื่อใช้ชื่ออินเทอร์เฟซ",
      "inboundTrust": "พันธมิตรรายนี้สามารถระบุอะไรเกี่ยวกับตัวตนของผู้ป่วยได้บ้าง การยืนยันตัวตนบอกว่าใครกำลังเชื่อมต่อ ส่วนการตั้งค่านี้บอกว่าอนุญาตให้พวกเขาแจ้งอะไรแก่เรา ให้คงค่าเริ่มต้นของการติดตั้งไว้ เว้นแต่ปลายทางนี้เป็นระบบหลักด้านการลงทะเบียนจริง ๆ"
    },
    "option": {
      "type": {
        "mllp": "MLLP (HL7 v2 บน TCP)",
        "hoh": "HoH (HL7 บน HTTPS)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "ไคลเอ็นต์ (ขาออก)",
        "server": "เซิร์ฟเวอร์ (ขาเข้า)"
      },
      "method": {
        "none": "ไม่มี",
        "basic": "HTTP Basic",
        "bearer": "โทเค็น Bearer",
        "clientCert": "ใบรับรองไคลเอ็นต์ (mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "AA ทันที (ค่าเริ่มต้นปัจจุบัน)",
        "honorMsh16": "อ่าน MSH-15/16 ต่อข้อความ",
        "forceSync": "ประมวลผลแบบอินไลน์ AA/AE/AR ตามผลลัพธ์",
        "forceEnhanced": "CA ทันที + ACK แอปผ่านช่องทางย้อนกลับ"
      },
      "outbound": {
        "fireAndForget": "ส่งแล้วไม่รอ (ค่าเริ่มต้นปัจจุบัน)",
        "expectSync": "ตั้ง MSH-16=AL ลองใหม่เมื่อ AE/AR",
        "expectEnhanced": "รอ CA + ACK แอปที่ตามมา"
      }
    },
    "validation": {
      "nameRequired": "ต้องระบุชื่อ",
      "hostRequired": "ต้องระบุโฮสต์",
      "mllpPort": "การเชื่อมต่อ MLLP ต้องมีพอร์ต",
      "portNumber": "พอร์ตต้องเป็นตัวเลข",
      "tlsServerCertKey": "เซิร์ฟเวอร์ TLS ต้องมีทั้งใบรับรองและคีย์",
      "basicUsername": "การยืนยันตัวตน Basic ต้องมีชื่อผู้ใช้",
      "basicPassword": "การยืนยันตัวตน Basic ต้องมีรหัสผ่าน",
      "bearerToken": "การยืนยันตัวตน Bearer ต้องมีโทเค็น",
      "enhancedReverse": "โหมด ACK ขั้นสูงต้องมีการเชื่อมต่อย้อนกลับ — เลือกหนึ่งรายการด้านล่าง",
      "outboundEvent": "\"{{value}}\" ไม่ใช่ข้อความที่ระบบนี้ส่ง — ใช้ประเภทเช่น ADT หรือเหตุการณ์เช่น ADT^A01"
    },
    "trust": {
      "useDeploymentDefault": "ใช้ค่าเริ่มต้นของการติดตั้ง",
      "observer": "ผู้สังเกตการณ์ — ไม่สร้างหรือแก้ไขผู้ป่วย",
      "demographics": "ข้อมูลประชากร — แก้ไขผู้ป่วยที่มีอยู่ได้ รวมถึงแจ้งการเสียชีวิต แต่ไม่สร้างใหม่",
      "registration": "การลงทะเบียน — สร้างผู้ป่วยและรวมเวชระเบียนได้ด้วย"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "การถ่ายภาพ",
    "laboratory": "ห้องปฏิบัติการ",
    "pharmacy": "เภสัชกรรม",
    "specialty": "เฉพาะทาง",
    "portal": "พอร์ทัล",
    "billing": "การเรียกเก็บเงิน",
    "other": "อื่น ๆ"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "เปลี่ยนเส้นทาง",
    "popup": "หน้าต่างป๊อปอัป",
    "iframe": "iframe",
    "newTab": "แท็บใหม่"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "แก้ไขกฎ CDS",
      "titleCreate": "สร้างกฎ CDS",
      "ruleName": "ชื่อกฎ",
      "ruleType": "ประเภทกฎ",
      "selectPlaceholder": "เลือก…",
      "severity": "ระดับความรุนแรง",
      "triggerEvent": "เหตุการณ์ทริกเกอร์",
      "actionType": "ประเภทการดำเนินการ",
      "description": "คำอธิบาย",
      "active": "เปิดใช้งาน",
      "cancel": "ยกเลิก",
      "submitUpdate": "อัปเดตกฎ",
      "submitCreate": "สร้างกฎ",
      "createdOk": "สร้างกฎสำเร็จ",
      "createFailed": "สร้างกฎไม่สำเร็จ",
      "updatedOk": "อัปเดตกฎสำเร็จ",
      "updateFailed": "อัปเดตกฎไม่สำเร็จ",
      "validation": {
        "nameRequired": "ต้องระบุชื่อกฎ",
        "typeRequired": "ต้องระบุประเภทกฎ",
        "descriptionRequired": "ต้องระบุคำอธิบาย",
        "triggerRequired": "ต้องระบุเหตุการณ์ทริกเกอร์",
        "actionRequired": "ต้องระบุประเภทการดำเนินการ"
      }
    },
    "list": {
      "title": "กฎ CDS",
      "subtitle": "จัดการกฎสนับสนุนการตัดสินใจทางคลินิก",
      "addRule": "เพิ่มกฎ",
      "loading": "กำลังโหลดกฎ CDS…",
      "loadError": "โหลดกฎ CDS ไม่สำเร็จ",
      "empty": "ยังไม่ได้กำหนดค่ากฎ CDS",
      "columns": {
        "ruleName": "ชื่อกฎ",
        "type": "ประเภท",
        "severity": "ระดับความรุนแรง",
        "description": "คำอธิบาย",
        "status": "สถานะ",
        "actions": "การดำเนินการ"
      },
      "toggleActive": "คลิกเพื่อปิดใช้งาน",
      "toggleInactive": "คลิกเพื่อเปิดใช้งาน",
      "active": "เปิดใช้งาน",
      "inactive": "ปิดใช้งาน",
      "editRule": "แก้ไขกฎ",
      "statusUpdated": "อัปเดตสถานะกฎแล้ว",
      "statusUpdateFailed": "อัปเดตสถานะกฎไม่สำเร็จ"
    }
  },
  "cdsSeverity": {
    "info": "ข้อมูล",
    "warning": "คำเตือน",
    "critical": "วิกฤต"
  },
  "cdsTriggerEvent": {
    "orderSign": "ลงนามคำสั่ง",
    "orderSelect": "เลือกคำสั่ง",
    "patientView": "ดูข้อมูลผู้ป่วย",
    "medicationPrescribe": "สั่งจ่ายยา",
    "resultReceived": "รับผลตรวจ",
    "patientAdmit": "รับผู้ป่วยเข้ารักษา"
  },
  "cdsActionType": {
    "alert": "การแจ้งเตือน",
    "warning": "คำเตือน",
    "hardStop": "หยุดบังคับ",
    "suggestion": "ข้อเสนอแนะ",
    "notification": "การแจ้ง"
  },
  "cdsRuleType": {
    "drugInteraction": "ปฏิกิริยาระหว่างยา",
    "drugAllergy": "การแพ้ยา",
    "duplicateOrder": "คำสั่งซ้ำ",
    "custom": "กำหนดเอง",
    "clinicalAlert": "การแจ้งเตือนทางคลินิก",
    "sepsisScreen": "การคัดกรองภาวะพิษเหตุติดเชื้อ"
  },
  "system": {
    "title": "การกำหนดค่าระบบ",
    "subtitle": "การตั้งค่าแอปพลิเคชัน ความปลอดภัย และสถานะระบบ",
    "restartServices": "รีสตาร์ตบริการ",
    "restartToast": "รีสตาร์ตบริการ (ตัวอย่าง - ต้องยืนยัน)",
    "loadError": "โหลดการกำหนดค่าระบบไม่สำเร็จ",
    "section": {
      "systemInfo": "ข้อมูลระบบ",
      "systemInfoDesc": "เวอร์ชัน เวลาทำงาน และสถานะบริการ",
      "general": "การตั้งค่าทั่วไป",
      "generalDesc": "ชื่อแอปพลิเคชัน เขตเวลา และแบรนด์",
      "security": "การตั้งค่าความปลอดภัย",
      "securityDesc": "นโยบายรหัสผ่าน MFA และการจัดการเซสชัน",
      "notifications": "การตั้งค่าการแจ้งเตือน",
      "notificationsDesc": "การกำหนดค่าเกตเวย์อีเมลและ SMS",
      "integration": "ค่าเริ่มต้นการเชื่อมต่อ",
      "integrationDesc": "การกำหนดค่าเริ่มต้น MLLP, FHIR และ HL7",
      "featureFlags": "แฟล็กฟีเจอร์",
      "featureFlagsDesc": "เปิดหรือปิดใช้งานฟีเจอร์ของระบบ",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "เวอร์ชัน",
      "uptime": "เวลาทำงาน",
      "database": "ฐานข้อมูล",
      "redis": "Redis",
      "microservices": "ไมโครเซอร์วิส",
      "conn": "การเชื่อมต่อ"
    },
    "uptime": {
      "running": "กำลังทำงาน",
      "unknown": "ไม่ทราบ",
      "up": "ทำงานอยู่"
    },
    "subsection": {
      "passwordPolicy": "นโยบายรหัสผ่าน",
      "mfa": "การยืนยันตัวตนหลายปัจจัย",
      "sessionLockout": "เซสชันและการล็อก",
      "emailConfig": "การกำหนดค่าอีเมล",
      "smsGateway": "เกตเวย์ SMS",
      "mllpDefaults": "ค่าเริ่มต้น MLLP",
      "fhirConfig": "การกำหนดค่า FHIR",
      "hl7Encoding": "การเข้ารหัส HL7 v2"
    },
    "fields": {
      "appName": "ชื่อแอปพลิเคชัน",
      "timezone": "เขตเวลา",
      "dateFormat": "รูปแบบวันที่",
      "supportEmail": "อีเมลฝ่ายสนับสนุน",
      "logoUrl": "URL โลโก้",
      "maintenanceMode": "โหมดบำรุงรักษา (ปิดการเข้าถึงของผู้ใช้)",
      "upload": "อัปโหลด",
      "minPasswordLength": "ความยาวรหัสผ่านขั้นต่ำ",
      "passwordExpiry": "รหัสผ่านหมดอายุ (วัน)",
      "requireUppercase": "ต้องมีตัวพิมพ์ใหญ่",
      "requireNumbers": "ต้องมีตัวเลข",
      "requireSpecialChars": "ต้องมีอักขระพิเศษ",
      "enableMfa": "เปิดใช้ MFA",
      "mfaMethod": "วิธี MFA",
      "sessionTimeout": "หมดเวลาเซสชัน (นาที)",
      "maxLoginAttempts": "จำนวนครั้งเข้าสู่ระบบสูงสุด",
      "lockoutDuration": "ระยะเวลาการล็อก (นาที)",
      "smtpHost": "โฮสต์ SMTP",
      "smtpPort": "พอร์ต SMTP",
      "smtpUser": "ผู้ใช้ SMTP",
      "fromEmail": "อีเมลผู้ส่ง",
      "useTls": "ใช้ TLS",
      "enabled": "เปิดใช้งาน",
      "provider": "ผู้ให้บริการ",
      "fromNumber": "หมายเลขผู้ส่ง",
      "defaultPort": "พอร์ตเริ่มต้น",
      "timeoutSeconds": "หมดเวลา (วินาที)",
      "retryCount": "จำนวนครั้งที่ลองใหม่",
      "fhirBaseUrl": "FHIR Base URL",
      "authMethod": "วิธีการยืนยันตัวตน",
      "fieldSeparator": "ตัวคั่นฟิลด์",
      "encodingChars": "อักขระเข้ารหัส",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "เอเชีย/สิงคโปร์ (UTC+8)",
        "hongKong": "เอเชีย/ฮ่องกง (UTC+8)",
        "kualaLumpur": "เอเชีย/กัวลาลัมเปอร์ (UTC+8)",
        "bangkok": "เอเชีย/กรุงเทพ (UTC+7)",
        "tokyo": "เอเชีย/โตเกียว (UTC+9)",
        "kolkata": "เอเชีย/โกลกาตา (UTC+5:30)",
        "sydney": "ออสเตรเลีย/ซิดนีย์ (UTC+11)"
      },
      "mfa": {
        "totp": "TOTP (แอปยืนยันตัวตน)",
        "sms": "SMS",
        "email": "อีเมล"
      },
      "fhirAuth": {
        "none": "ไม่มี",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "บันทึกการตั้งค่าทั่วไป",
      "security": "บันทึกการตั้งค่าความปลอดภัย",
      "notifications": "บันทึกการตั้งค่าการแจ้งเตือน",
      "integration": "บันทึกการตั้งค่าการเชื่อมต่อ",
      "features": "บันทึกแฟล็กฟีเจอร์",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "ทั่วไป",
      "security": "ความปลอดภัย",
      "notifications": "การแจ้งเตือน",
      "integration": "การเชื่อมต่อ",
      "features": "แฟล็กฟีเจอร์",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "อัปโหลดโลโก้ (ตัวอย่าง)",
      "saved": "บันทึกการตั้งค่า{{section}}สำเร็จแล้ว",
      "saveFailed": "บันทึกการตั้งค่าไม่สำเร็จ"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "การรวมผู้ป่วย",
        "description": "เปิดใช้งานฟังก์ชันการรวม/แยกผู้ป่วย"
      },
      "breakGlass": {
        "label": "การเข้าถึงฉุกเฉิน",
        "description": "อนุญาตการแทนที่ฉุกเฉินสำหรับระเบียนที่จำกัด"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "เปิดเผยเอนด์พอยต์ FHIR R4 สำหรับระบบภายนอก"
      },
      "smartApps": {
        "label": "แอป SMART on FHIR",
        "description": "อนุญาตให้แอป SMART ของบุคคลที่สามเชื่อมต่อ"
      },
      "clinicalDecisionSupport": {
        "label": "การสนับสนุนการตัดสินใจทางคลินิก",
        "description": "เปิดใช้งาน CDS hooks สำหรับการป้อนคำสั่ง"
      },
      "telemedicine": {
        "label": "โมดูลโทรเวชกรรม",
        "description": "การปรึกษาผ่านวิดีโอและการติดตามระยะไกล"
      },
      "patientPortal": {
        "label": "พอร์ทัลผู้ป่วย",
        "description": "พอร์ทัลสำหรับผู้ป่วยเพื่อดูระเบียนและการนัดหมาย"
      },
      "analyticsDashboard": {
        "label": "แดชบอร์ดการวิเคราะห์",
        "description": "แดชบอร์ดการวิเคราะห์และรายงานขั้นสูง"
      },
      "medicationBarcode": {
        "label": "การสแกนบาร์โค้ดยา",
        "description": "การตรวจสอบบาร์โค้ดสำหรับการบริหารยา"
      },
      "autoCoding": {
        "label": "การเข้ารหัสอัตโนมัติ (ICD/CPT)",
        "description": "การเข้ารหัสการวินิจฉัยและหัตถการด้วย AI"
      }
    }
  },
  "audit": {
    "title": "บันทึกการตรวจสอบ",
    "subtitle": "บันทึกกิจกรรมของระบบพร้อมการติดตามการเปลี่ยนแปลงโดยละเอียด",
    "exportCsv": "ส่งออก CSV",
    "exportToast": "กำลังส่งออกรายการตรวจสอบ {{count}} รายการเป็น CSV (ตัวอย่าง)",
    "searchPlaceholder": "ค้นหาตามผู้ใช้…",
    "advanced": "ขั้นสูง",
    "breakGlassOnly": "เฉพาะเข้าถึงฉุกเฉิน",
    "fromTo": "จาก / ถึง:",
    "fromDate": "วันที่เริ่มต้น",
    "toDate": "วันที่สิ้นสุด",
    "clearFilters": "ล้างตัวกรองทั้งหมด",
    "entriesFound": "พบ {{count}} รายการ",
    "noMatch": "ไม่มีรายการตรวจสอบที่ตรงกับตัวกรองของคุณ",
    "viewDetails": "ดูรายละเอียด",
    "detail": {
      "title": "รายละเอียดรายการตรวจสอบ",
      "timestamp": "ประทับเวลา",
      "user": "ผู้ใช้",
      "action": "การดำเนินการ",
      "resource": "ทรัพยากร",
      "ipAddress": "ที่อยู่ IP",
      "breakGlass": "เข้าถึงฉุกเฉิน",
      "yes": "ใช่",
      "no": "ไม่",
      "details": "รายละเอียด",
      "dataChanges": "การเปลี่ยนแปลงข้อมูล",
      "before": "ก่อน",
      "after": "หลัง",
      "result": "ผลลัพธ์"
    },
    "columns": {
      "timestamp": "ประทับเวลา",
      "user": "ผู้ใช้",
      "action": "การดำเนินการ",
      "resource": "ทรัพยากร",
      "resourceId": "รหัสทรัพยากร",
      "ipAddress": "ที่อยู่ IP",
      "details": "รายละเอียด",
      "view": "ดู"
    },
    "filter": {
      "action": {
        "all": "การดำเนินการทั้งหมด",
        "create": "สร้าง",
        "read": "อ่าน",
        "update": "อัปเดต",
        "delete": "ลบ",
        "login": "เข้าสู่ระบบ",
        "logout": "ออกจากระบบ",
        "export": "ส่งออก",
        "breakGlass": "เข้าถึงฉุกเฉิน"
      },
      "resource": {
        "all": "ทรัพยากรทั้งหมด",
        "patient": "ผู้ป่วย",
        "encounter": "การเข้ารับบริการ",
        "order": "คำสั่ง",
        "result": "ผลลัพธ์",
        "medication": "ยา",
        "user": "ผู้ใช้",
        "system": "ระบบ"
      }
    },
    "pagination": {
      "first": "หน้าแรก",
      "last": "หน้าสุดท้าย",
      "pageOf": "หน้า {{page}} จาก {{pages}}",
      "range": "{{from}}-{{to}} จาก {{total}}"
    }
  },
  "taxonomy": {
    "title": "อนุกรมวิธานทางคลินิก",
    "subtitle": "สายบริการจัดกลุ่มบริการทางคลินิกที่เกี่ยวข้อง (Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic) ทั้งสองป้อนเข้าสู่เมทริกซ์การกำหนดบริการ ↔ สถานที่ ที่ใช้ในการจัดตารางเวลา",
    "addServiceLine": "เพิ่มสายบริการ",
    "addClinicalService": "เพิ่มบริการทางคลินิก",
    "tabs": {
      "serviceLines": "สายบริการ",
      "clinicalServices": "บริการทางคลินิก"
    },
    "searchLines": "ค้นหาสายบริการ...",
    "searchServices": "ค้นหาบริการทางคลินิก...",
    "empty": {
      "linesNone": "ยังไม่มีการกำหนดค่าสายบริการ",
      "linesNoMatch": "ไม่มีสายบริการที่ตรงกัน",
      "servicesNone": "ยังไม่มีการกำหนดค่าบริการทางคลินิก",
      "servicesNoMatch": "ไม่มีบริการทางคลินิกที่ตรงกัน"
    },
    "columns": {
      "name": "ชื่อ",
      "code": "รหัส",
      "description": "คำอธิบาย",
      "services": "บริการ",
      "status": "สถานะ",
      "serviceLine": "สายบริการ",
      "specialty": "ความเชี่ยวชาญ",
      "actions": "การดำเนินการ"
    },
    "status": {
      "active": "ใช้งาน",
      "inactive": "ปิดใช้งาน"
    },
    "editTitle": "แก้ไข"
  },
  "systemStatus": {
    "connected": "เชื่อมต่อแล้ว",
    "error": "ข้อผิดพลาด"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "มีผู้รับผิดชอบ {{count}} คน",
      "unstaffedBadge": "ไม่มีผู้รับผิดชอบ",
      "unstaffedWarning": "บทบาทเหล่านี้ไม่มีผู้รับผิดชอบ ระดับดังกล่าวจึงจะไม่แจ้งเตือนใครเลย: {{roles}} กรุณากำหนดบทบาทให้เจ้าหน้าที่ที่ ผู้ดูแลระบบ → ผู้ใช้"
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
